import './shared/Requerimiento.css';
import { RequerimientoTendencia, RequerimientoDistribucion } from './shared/RequerimientoCharts';
import { PharmacySelect, PharmacyMetric, PharmacyPagination, PharmacyDownloadDialog, PharmacyTabs } from './shared/PharmacyUI';
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography, CircularProgress, Tooltip, Autocomplete, TextField, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS as BaseIOS } from './shared/MenuLayout';

const IOS = {...BaseIOS,blue:'#548EE6',purple:'#8B7CC8',green:'#55A884',orange:'#CF9550',red:'#CF6979',label:'#29364A',label2:'#7C899C',separator:'#E7ECF3',bg:'#F5F7FB'};

const getPeriodo = () => { const n=new Date(); return `${n.getFullYear()}${String(n.getMonth()+1).padStart(2,'0')}`; };
const fmt2 = (v) => parseFloat(v||0).toFixed(2);
const fmt0 = (v) => Math.round(parseFloat(v||0)).toLocaleString();

const IND_CFG = {
  'SOBRESTOCK':   { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#34C759' },
  'NORMOSTOCK':   { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#22C55E' },
  'SUBSTOCK':     { bg:'#FFF8E6', border:'#FFE9A0', text:'#8B6914', dot:'#FF9500' },
  'DESABASTECIDO':{ bg:'#FFF0EF', border:'#FFD4D1', text:'#C0392B', dot:'#FF3B30' },
  'SIN ROTACION': { bg:'#F2F2F7', border:'#D1D1D6', text:'#636366', dot:'#8E8E93' },
  'SIN CONSUMO':  { bg:'#F2F2F7', border:'#D1D1D6', text:'#636366', dot:'#8E8E93' },
  'NO APLICA':    { bg:'#F0EFFF', border:'#C7C7F0', text:'#3730A3', dot:'#5E5CE6' },
};
const getInd = (v) => IND_CFG[v?.toUpperCase()] || { bg:IOS.bg, border:IOS.separator, text:IOS.label2, dot:IOS.label3 };

const IndPill = ({ valor }) => {
  const cfg = getInd(valor);
  return (
    <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2,
      borderRadius:'20px', bgcolor:cfg.bg, border:`1px solid ${cfg.border}` }}>
      <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:cfg.dot, flexShrink:0 }} />
      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:cfg.text, whiteSpace:'nowrap' }}>
        {valor||'SIN CLASIFICAR'}
      </Typography>
    </Box>
  );
};

const Sel = PharmacySelect;

const MultiSelectInd = ({ opciones, seleccionados, onChange }) => (
  <div className="pharmacy-field req-indicator-filter"><label>Indicador</label>
    <Autocomplete multiple disableCloseOnSelect autoSelect={false} options={opciones} value={seleccionados} onChange={(_,values)=>onChange(values)} limitTags={1}
      renderOption={(props,op,{selected})=>{const {key,...rest}=props;return <li {...rest} key={op}><Checkbox checked={selected} size="small" tabIndex={-1} disableRipple/><span style={{width:7,height:7,borderRadius:'50%',background:getInd(op).dot,marginRight:8}}/>{op}</li>;}}
      renderInput={params=><TextField {...params} size="small" placeholder={seleccionados.length?'':'Todos los indicadores'} inputProps={{...params.inputProps,'aria-label':'Indicador'}}/>}
      componentsProps={{paper:{sx:{borderRadius:2.5,border:'1px solid #E7ECF3',boxShadow:'0 12px 32px #293e5d18',fontSize:12}}}}/>
  </div>
);

const DIAS_SEMANA = ['D','L','M','M','J','V','S'];
const MESES_LARGO = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const parseYMD = (s) => { if(!s) return null; const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };

const DatePickerIOS = ({ value, onChange, minDate, w='100%' }) => {
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);
  const ref = useRef(null);
  const popupRef = useRef(null);
  const selDate = parseYMD(value);
  const [viewMonth, setViewMonth] = useState(selDate ? selDate.getMonth() : new Date().getMonth());
  const [viewYear, setViewYear] = useState(selDate ? selDate.getFullYear() : new Date().getFullYear());

  useEffect(() => {
    const h = e => {
      const dentroTrigger = ref.current && ref.current.contains(e.target);
      const dentroPopup = popupRef.current && popupRef.current.contains(e.target);
      if (!dentroTrigger && !dentroPopup) setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const handleOpen = () => {
    if (ref.current) setRect(ref.current.getBoundingClientRect());
    if (selDate) { setViewMonth(selDate.getMonth()); setViewYear(selDate.getFullYear()); }
    setOpen(v=>!v);
  };

  const cambiarMes = (delta) => {
    let m = viewMonth + delta, y = viewYear;
    if (m < 0) { m = 11; y--; } else if (m > 11) { m = 0; y++; }
    setViewMonth(m); setViewYear(y);
  };

  const elegirDia = (dia) => {
    const fecha = new Date(viewYear, viewMonth, dia);
    const min = minDate ? parseYMD(minDate) : null;
    if (min && fecha < min) return;
    onChange(toYMD(fecha));
    setOpen(false);
  };

  const hoyD = new Date();
  const minD = minDate ? parseYMD(minDate) : null;
  const primerDiaSemana = new Date(viewYear, viewMonth, 1).getDay();
  const totalDias = new Date(viewYear, viewMonth+1, 0).getDate();
  const celdas = [...Array(primerDiaSemana).fill(null), ...Array.from({length:totalDias},(_,i)=>i+1)];
  const labelFecha = selDate ? `${String(selDate.getDate()).padStart(2,'0')}/${String(selDate.getMonth()+1).padStart(2,'0')}/${selDate.getFullYear()}` : '';

  return (
    <Box ref={ref} sx={{ position:'relative', width:w }}>
      <Box className="pharmacy-layout req-date-trigger" component="button" type="button" aria-label="Seleccionar fecha" aria-expanded={open} onClick={handleOpen} onKeyDown={e=>{if(e.key==='Escape')setOpen(false);}}
        sx={{ height:36, px:1.2, display:'flex', alignItems:'center', gap:0.8,
          border:`1px solid ${open?IOS.blue:IOS.separator}`, borderRadius:'8px',
          bgcolor:IOS.surface, cursor:'pointer', userSelect:'none',
          boxShadow:'none', transition:'all 0.15s', boxSizing:'border-box' }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <Typography sx={{ fontSize:'0.82rem', color:value?IOS.label:IOS.label2, flex:1, whiteSpace:'nowrap' }}>{labelFecha||'Seleccionar...'}</Typography>
      </Box>

      {open && rect && ReactDOM.createPortal(
        <Box className="req-calendar" ref={popupRef} sx={{ position:'fixed', top:rect.bottom+4, left:Math.max(8,Math.min(rect.left,window.innerWidth-284)), zIndex:99999,
          bgcolor:IOS.surface, border:`1px solid ${IOS.separator}`, borderRadius:'14px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.16)', width:260, p:1.5 }}>

          <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>cambiarMes(-1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            </Box>
            <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:IOS.label }}>{MESES_LARGO[viewMonth]} {viewYear}</Typography>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>cambiarMes(1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </Box>
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', mb:0.5 }}>
            {DIAS_SEMANA.map((d,i)=>(<Typography key={i} sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textAlign:'center' }}>{d}</Typography>))}
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'2px' }}>
            {celdas.map((dia,i)=>{
              if (dia===null) return <Box key={i} />;
              const fechaCelda = new Date(viewYear, viewMonth, dia);
              const deshabilitado = minD && fechaCelda < minD;
              const esHoy = dia===hoyD.getDate() && viewMonth===hoyD.getMonth() && viewYear===hoyD.getFullYear();
              const esSel = selDate && dia===selDate.getDate() && viewMonth===selDate.getMonth() && viewYear===selDate.getFullYear();
              return (
                <Box className="pharmacy-layout" key={i} onClick={()=>!deshabilitado&&elegirDia(dia)}
                  sx={{ height:30, display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'8px',
                    cursor:deshabilitado?'not-allowed':'pointer', opacity:deshabilitado?0.3:1,
                    bgcolor:esSel?IOS.blue:'transparent',
                    border:esHoy&&!esSel?`1.5px solid ${IOS.blue}`:'none' }}>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:esSel?700:500, color:esSel?'white':IOS.label }}>{dia}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>, document.body
      )}
    </Box>
  );
};

const KpiCard = PharmacyMetric;

const Paginacion = PharmacyPagination;

const ModalExportar = ({ open, onClose, total, onExportar, exportando }) => (<PharmacyDownloadDialog open={open} onClose={onClose} total={total} busy={exportando} options={[{fmt:'pdf',label:'Descargar PDF',onClick:()=>onExportar('pdf')},{fmt:'excel',label:'Descargar Excel',onClick:()=>onExportar('excel')}]}/>);

// ── Historial ─────────────────────────────────────────────────────────────────
const HistorialRequerimientos = ({ historial, loading, esTOTAL, estados, onRecargar, onVerDetalle, ipressList, filtroIpress, setFiltroIpress }) => {
  const [filtroEst, setFiltroEst] = useState('');
  const _hoy = new Date();
  const [fechaIni, setFechaIni] = useState(`${_hoy.getFullYear()}-${String(_hoy.getMonth()+1).padStart(2,'0')}-01`);
  const [fechaFin, setFechaFin] = useState(toYMD(_hoy));
  const [soloPend, setSoloPend] = useState(false);

  const esPendiente = r => !['ENTREGADO','RECHAZADO'].includes(r.REQ_ESTADO);
  const enRango = r => {
    const f = String(r.REQ_FECHA_ENVIO||'').substring(0,10);
    return (!fechaIni || f>=fechaIni) && (!fechaFin || f<=fechaFin);
  };

  const base  = soloPend ? historial.filter(esPendiente) : historial.filter(enRango);
  const lista = filtroEst ? base.filter(r=>r.REQ_ESTADO===filtroEst) : base;
  const totalPend = historial.filter(esPendiente).length;

  if(loading) return <Box sx={{py:12,textAlign:'center'}}><CircularProgress sx={{color:IOS.blue}}/></Box>;

  const LblF = ({children}) => (
    <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
      letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>{children}</Typography>
  );

  return (
    <Box>
      {/* ── Banner de pendientes ── */}
      {totalPend>0 && (
        <Box className="pharmacy-layout" sx={{mb:2,p:1.8,borderRadius:'14px',bgcolor:'#FFF8E6',border:'1px solid #FFE9A0',
          display:'flex',alignItems:'center',gap:1.2,flexWrap:'wrap'}}>
          <Box className="pharmacy-layout" sx={{width:32,height:32,borderRadius:'10px',bgcolor:'#FDE68A',flexShrink:0,
            display:'flex',alignItems:'center',justifyContent:'center'}}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#92400E" strokeWidth="2" strokeLinecap="round">
              <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
          </Box>
          <Box sx={{flex:1,minWidth:180}}>
            <Typography sx={{fontSize:'0.8rem',fontWeight:700,color:'#8B6914'}}>
              {totalPend} requerimiento{totalPend!==1?'s':''} pendiente{totalPend!==1?'s':''} de entrega
            </Typography>
            <Typography sx={{fontSize: '0.72rem',color:'#A16207'}}>
              {soloPend ? 'Mostrando solo pendientes, sin filtro de fechas' : 'Incluye requerimientos fuera del rango de fechas seleccionado'}
            </Typography>
          </Box>
          <Box className="pharmacy-action" component="button" onClick={()=>{setSoloPend(v=>!v);setFiltroEst('');}}
            sx={{height:32,px:1.8,borderRadius:'10px',border:'none',cursor:'pointer',
              bgcolor:soloPend?'#8B6914':'#FDE68A',transition:'all 0.15s',
              '&:hover':{filter:'brightness(0.95)'}}}>
            <Typography sx={{fontSize:'0.75rem',fontWeight:700,color:soloPend?'white':'#92400E'}}>
              {soloPend?'Ver todos':'Ver pendientes'}
            </Typography>
          </Box>
        </Box>
      )}

      {/* ── Toolbar ── */}
      <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2,mb:2,
        boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>

        {/* Fila 1: fechas + IPRESS + refresh + contador */}
        <Box className="pharmacy-layout pharmacy-toolbar req-toolbar" sx={{display:'flex',alignItems:'flex-end',gap:1.5,flexWrap:'wrap',mb:1.5,
          opacity:1,transition:'opacity 0.2s'}}>
          <Box sx={{opacity:soloPend?0.4:1,pointerEvents:soloPend?'none':'auto'}}>
            <LblF>Desde</LblF>
            <DatePickerIOS value={fechaIni} onChange={setFechaIni} w={130}/>
          </Box>
          <Box sx={{opacity:soloPend?0.4:1,pointerEvents:soloPend?'none':'auto'}}>
            <LblF>Hasta</LblF>
            <DatePickerIOS value={fechaFin} onChange={setFechaFin} w={130}/>
          </Box>
          <Box>
            <LblF>IPRESS</LblF>
            {esTOTAL
              ?<Sel value={filtroIpress} onChange={e=>{setFiltroIpress(e.target.value);onRecargar();}} w={280}>
                <option value="">Todas</option>
                {ipressList.map(ip=><option key={ip.id} value={ip.id}>{ip.nombre}</option>)}
              </Sel>
              :<Box className="pharmacy-layout" sx={{height:34,px:1.5,display:'flex',alignItems:'center',
                border:`1px solid ${IOS.separator}`,borderRadius:'8px',
                bgcolor:IOS.bg,minWidth:220,opacity:0.6}}>
                <Typography sx={{fontSize:'0.8rem',color:IOS.label2,overflow:'hidden',
                  textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {ipressList[0]?.nombre||'Mi IPRESS'}
                </Typography>
              </Box>
            }
          </Box>
          <Box className="pharmacy-layout pharmacy-action" component="button" onClick={onRecargar}
            sx={{width:34,height:34,borderRadius:'10px',border:`1px solid ${IOS.separator}`,
              bgcolor:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',
              justifyContent:'center',transition:'all 0.15s','&:hover':{bgcolor:IOS.bg}}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
              <polyline points="23 4 23 10 17 10"/>
              <path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
            </svg>
          </Box>
          <Typography sx={{fontSize:'0.72rem',color:IOS.label2,ml:'auto',alignSelf:'center'}}>
            {lista.length.toLocaleString()} de {historial.length.toLocaleString()} requerimientos
          </Typography>
        </Box>

        {/* Fila 2: pills de estado */}
        <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1,flexWrap:'wrap',pt:1.5,
          borderTop:`1px solid ${IOS.separator}`}}>
          {['','ENVIADO','RECIBIDO','EN_EVALUACION','APROBADO','EN_PREPARACION','LISTO','ENTREGADO','RECHAZADO'].map(e=>{
            const cfg = estados[e] || {label:'Todos',dot:IOS.label3,bg:IOS.bg,border:IOS.separator,text:IOS.label2};
            const cnt = e ? base.filter(r=>r.REQ_ESTADO===e).length : base.length;
            if(!e){ return(
              <Box component="button" type="button" aria-pressed={filtroEst===''} key="todos" onClick={()=>setFiltroEst('')}
                sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:1.2,py:0.5,cursor:'pointer',
                  borderRadius:'20px',border:`1px solid ${filtroEst===''?IOS.blue:IOS.separator}`,
                  bgcolor:filtroEst===''?`${IOS.blue}08`:IOS.surface,transition:'all 0.15s'}}>
                <Typography sx={{fontSize:'0.7rem',fontWeight:filtroEst===''?700:500,
                  color:filtroEst===''?IOS.blue:IOS.label2}}>Todos ({base.length})</Typography>
              </Box>
            );}
            if(!cnt) return null;
            return(
              <Box component="button" type="button" aria-pressed={filtroEst===e} key={e} onClick={()=>setFiltroEst(filtroEst===e?'':e)}
                sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:1.2,py:0.5,cursor:'pointer',
                  borderRadius:'20px',border:`1px solid ${filtroEst===e?cfg.dot:IOS.separator}`,
                  bgcolor:filtroEst===e?cfg.bg:IOS.surface,transition:'all 0.15s'}}>
                <Box sx={{width:5,height:5,borderRadius:'50%',bgcolor:cfg.dot}}/>
                <Typography sx={{fontSize:'0.7rem',fontWeight:filtroEst===e?700:500,
                  color:filtroEst===e?cfg.text:IOS.label2}}>{cfg.label} ({cnt})</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
      {lista.length===0
        ?<Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',py:10,textAlign:'center',border:`1px solid ${IOS.separator}`}}>
          <Typography sx={{color:IOS.label2}}>Sin requerimientos{filtroEst?' en este estado':''}</Typography>
        </Box>
        
        :<Box className="pharmacy-layout" sx={{display:'flex',flexDirection:'column',gap:1.5}}>
          {lista.map(req=>{
            const cfg = estados[req.REQ_ESTADO] || {label:req.REQ_ESTADO,dot:IOS.label3,bg:IOS.bg,border:IOS.separator,text:IOS.label2};
            const fecha = req.REQ_FECHA_ENVIO ? new Date(req.REQ_FECHA_ENVIO).toLocaleDateString('es-PE',{day:'2-digit',month:'short',year:'numeric'}) : '';
            return(
              <Box className="pharmacy-card req-history-card" role="button" tabIndex={0} aria-label={`Ver requerimiento ${req.REQ_NUMERO}`} onKeyDown={e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();onVerDetalle(req);}}} key={req.REQ_ID} onClick={()=>onVerDetalle(req)}
                sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2.5,
                  boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,
                  cursor:'pointer',transition:'all 0.2s',
                  '&:hover':{boxShadow:'0 4px 16px rgba(0,0,0,0.1)',transform:'translateY(-1px)',borderColor:cfg.dot}}}>
                <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:2}}>
                  <Box sx={{flex:1,minWidth:0}}>
                    <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.2,mb:0.8}}>
                      <Typography sx={{fontSize:'1.1rem',fontWeight:800,color:IOS.blue,
                        letterSpacing:'-0.02em',fontFamily:'ui-monospace,monospace'}}>
                        {req.REQ_NUMERO}
                      </Typography>
                      <Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:1,py:0.3,
                        borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`}}>
                        <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:cfg.dot}}/>
                        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text}}>{cfg.label}</Typography>
                      </Box>
                    </Box>
                    <Typography sx={{fontSize:'0.78rem',color:IOS.label2,mb:1}}>
                      {esTOTAL ? req.NOMBRE_IPRESS : req.NOMBRE_ALMACEN} · {fecha}
                    </Typography>
                    <Box className="pharmacy-layout" sx={{display:'flex',gap:2,flexWrap:'wrap'}}>
                      <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
                        <strong style={{color:IOS.label}}>{req.TOTAL_LINEAS}</strong> productos
                      </Typography>
                      <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
                        <strong style={{color:IOS.label}}>{parseFloat(req.TOTAL_SOLICITADO||0).toLocaleString()}</strong> unidades
                      </Typography>
                      <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
                        {req.REQ_TIPO==='C'?'Completo':'Med. Esenciales'} · {req.REQ_MESES} mes(es)
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="pharmacy-layout" sx={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:1,flexShrink:0}}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                    {req.REQ_NRO_GUIA_SISMED&&(
                      <Typography sx={{fontSize: '0.72rem',color:IOS.label2,fontFamily:'monospace'}}>
                        Guía: {req.REQ_NRO_GUIA_SISMED}
                      </Typography>
                    )}
                  </Box>
                </Box>
                {/* Barra de progreso de estado */}
                {(()=>{
                  const pasos = ['ENVIADO','RECIBIDO','EN_EVALUACION','APROBADO','EN_PREPARACION','LISTO','ENTREGADO'];
                  const idx = pasos.indexOf(req.REQ_ESTADO);
                  const pct = idx>=0 ? Math.round(((idx+1)/pasos.length)*100) : 0;
                  if(req.REQ_ESTADO==='RECHAZADO') return(
                    <Box sx={{mt:1.5,pt:1.5,borderTop:`1px solid ${IOS.separator}`}}>
                      <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:0.6}}>
                        <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:'#FF3B30'}}/>
                        <Typography sx={{fontSize: '0.72rem',color:'#C0392B',fontWeight:600}}>
                          Rechazado — {req.REQ_MENSAJE_RECHAZO||'Sin mensaje'}
                        </Typography>
                      </Box>
                    </Box>
                  );
                  return(
                    <Box sx={{mt:1.5,pt:1.5,borderTop:`1px solid ${IOS.separator}`}}>
                      <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',mb:0.5}}>
                        <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>Progreso</Typography>
                        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text}}>{pct}%</Typography>
                      </Box>
                      <Box sx={{height:4,bgcolor:IOS.bg,borderRadius:'20px',overflow:'hidden'}}>
                        <Box sx={{width:`${pct}%`,height:'100%',bgcolor:cfg.dot,
                          borderRadius:'20px',transition:'width 0.8s ease'}}/>
                      </Box>
                      <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',mt:0.6}}>
                        {pasos.map((p,i)=>(
                          <Box className="pharmacy-layout" key={p} sx={{display:'flex',flexDirection:'column',alignItems:'center',gap:0.3}}>
                            <Box sx={{width:8,height:8,borderRadius:'50%',
                              bgcolor:i<=idx?cfg.dot:IOS.separator,
                              transition:'background 0.3s'}}/>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  );
                })()}
              </Box>
            );
          })}
        </Box>
      }
    </Box>
  );
};



// ── Detalle requerimiento ─────────────────────────────────────────────────────
const DetalleRequerimiento = ({ req, esTOTAL, estados, user, ueId, onVolver, onCambiarEstado, onRecargar, api }) => {
  const { cabecera, lineas } = req;
  const cfg = estados[cabecera.REQ_ESTADO] || {label:cabecera.REQ_ESTADO,dot:IOS.label3,bg:IOS.bg,border:IOS.separator,text:IOS.label2};
  const [accion, setAccion] = useState(null); // modal de acción
  const [mensaje, setMensaje] = useState('');
  const [nroGuia, setNroGuia] = useState(cabecera.REQ_NRO_GUIA_SISMED||'');
  const [nroItems, setNroItems] = useState(cabecera.REQ_NRO_ITEMS||'');
  const [nroBultos, setNroBultos] = useState(cabecera.REQ_NRO_BULTOS||'');
  const [pesoKg, setPesoKg] = useState(cabecera.REQ_PESO_KG||'');
  const [pdfFile, setPdfFile] = useState(null);
  const [subiendoPdf, setSubiendoPdf] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [modalNotif, setModalNotif] = useState(null);

  const [imprimiendo, setImprimiendo] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [modalPdfGuia, setModalPdfGuia] = useState(false);

  useEffect(()=>{
    setModoEval(false);
  },[cabecera.REQ_ESTADO]);

  const imprimirRequerimiento = async () => {
    setImprimiendo(true);
    try {
      const r = await api.post(`/farmacia/requerimiento/${cabecera.REQ_ID}/imprimir-pdf`,{},
        {params:{idEstablecimiento:user?.idEstablecimiento||user?.IdEstablecimiento||0},responseType:'blob'});
      const url = window.URL.createObjectURL(new Blob([r.data],{type:'application/pdf'}));
      const a = document.createElement('a');
      a.href = url;
      a.download = `Requerimiento_${cabecera.REQ_NUMERO}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch(e){ console.error(e); } finally { setImprimiendo(false); }
  };

  const [modoEval, setModoEval]         = useState(false);
  const [lineasEval, setLineasEval]     = useState([]);
  const [loadEval, setLoadEval]         = useState(false);
  const [guardandoEval, setGuardandoEval] = useState(false);
  const [modalAgregar, setModalAgregar]   = useState(false);
  const [buscarProd,   setBuscarProd]     = useState('');
  const [prodAlmacen,  setProdAlmacen]    = useState([]);
  const [loadProd,     setLoadProd]       = useState(false);
  const [prodSelec,    setProdSelec]      = useState(null); // producto elegido
  const [cantAgregar,  setCantAgregar]    = useState('');
  const [obsAgregar,   setObsAgregar]     = useState('');
  const [agregando,    setAgregando]      = useState(false);
  const [modalRetroceder, setModalRetroceder] = useState(false);
  const [modalCancelar,   setModalCancelar]   = useState(false);
  const [motivoCancelar,  setMotivoCancelar]  = useState('');
  const [procesandoRet,   setProcesandoRet]   = useState(false);
  const [modalRecojo, setModalRecojo]   = useState(false);
  const [fechaRecojo, setFechaRecojo]   = useState('');
  const [horaRecojo, setHoraRecojo]     = useState('');
  const [recojosDia, setRecojosDia]     = useState([]);
  const [loadRecojo, setLoadRecojo]     = useState(false);
  const [guardandoRecojo, setGuardandoRecojo] = useState(false);
  const [modalPdf, setModalPdf]         = useState(false);
  

  const subirPdf = async () => {
    if(!pdfFile) return null;
    setSubiendoPdf(true);
    try {
      const form = new FormData();
      form.append('archivo', pdfFile);
      const r = await api.post(`/farmacia/requerimiento/${cabecera.REQ_ID}/subir-pdf`, form, {
        headers:{'Content-Type':'multipart/form-data'}
      });
      return r.data.success ? r.data.path : null;
    } catch(e){ console.error(e); return null; }
    finally { setSubiendoPdf(false); }
  };

  const cargarEvaluacion = async () => {
    setLoadEval(true);
    try {
      const r = await api.get(`/farmacia/requerimiento/${cabecera.REQ_ID}/evaluar`, {
        params: { ueId }
      });
      if(r.data.success){
        setLineasEval(r.data.data
          .filter(l=>!l.DET_SIN_STOCK)
          .map(l=>({
            ...l,
            _propuesta: l.CANT_PROPUESTA ?? l.CANT_SUGERIDA ?? 0,
            _obs: l.OBS_ALMACEN || ''
          })));
        setModoEval(true);
      }
    } catch(e){ console.error(e); } finally { setLoadEval(false); }
  };

  const guardarEvaluacion = async () => {
    const exceden = lineasEval.filter(l=>parseFloat(l._propuesta||0)>parseFloat(l.STOCK_ACTUAL_ALMACEN||l.STOCK_ALMACEN||0));
    if(exceden.length>0){
      setModalNotif({
        tipo: 'warning',
        titulo: `${exceden.length} producto(s) superan el stock`,
        mensaje: 'Las siguientes líneas tienen una cantidad propuesta mayor al stock disponible en almacén:',
        cols: ['Producto','Propuesto','Stock disponible'],
        items: exceden.slice(0,20).map(l=>[
          l.PRODUCTO?.substring(0,40)+(l.PRODUCTO?.length>40?'...':''),
          parseFloat(l._propuesta||0).toLocaleString(),
          parseFloat(l.STOCK_ACTUAL_ALMACEN||l.STOCK_ALMACEN||0).toLocaleString(),
        ])
      });
      return;
    }
    setGuardandoEval(true);
    try {
      const items = lineasEval.map(l=>({
        detId: l.DET_ID,
        cantPropuesta: parseFloat(l._propuesta||0),
        obs: l._obs||null
      }));
      const r = await api.put(`/farmacia/requerimiento/${cabecera.REQ_ID}/guardar-evaluacion`, items);
      if(r.data.success){ setModoEval(false); onRecargar(); }
    } catch(e){ console.error(e); } finally { setGuardandoEval(false); }
  };

  const cargarRecojosDia = async (fecha) => {
    if(!fecha) return;
    try {
      const r = await api.get('/farmacia/requerimiento/recojos-dia', { params:{ fecha, ueId } });
      if(r.data.success) setRecojosDia(r.data.data);
    } catch(e){ console.error(e); }
  };

  const buscarProductos = async (q) => {
    setBuscarProd(q);
    if(q.length < 3){ setProdAlmacen([]); return; }
    setLoadProd(true);
    try {
      const r = await api.get('/farmacia/requerimiento/productos-almacen', {
        params: { ueId, buscar: q }
      });
      if(r.data.success) setProdAlmacen(r.data.data);
    } catch(e){ console.error(e); } finally { setLoadProd(false); }
  };

  const marcarSinStock = async () => {
    const sinStock = lineasEval.filter(l=>parseFloat(l.STOCK_ACTUAL_ALMACEN||l.STOCK_ALMACEN||0)===0);
    if(sinStock.length===0) return;
    try {
      const ids = sinStock.map(l=>l.DET_ID);
      const r = await api.post(`/farmacia/requerimiento/${cabecera.REQ_ID}/marcar-sin-stock`, { ids });
      if(r.data.success){
        setModalNotif({
          tipo:'success',
          titulo:`${r.data.afectados} productos ocultados`,
          mensaje:'Los productos sin stock fueron ocultados del requerimiento. Podrás consultarlos después para analizar la demanda insatisfecha.'
        });
        await cargarEvaluacion();
      }
    } catch(e){ console.error(e); }
  };

  const agregarLinea = async () => {
    if(!prodSelec||!cantAgregar||!obsAgregar.trim()) return;
    const existe = lineasEval.some(l=>l.MEDCOD===prodSelec.medcod);
    if(existe){
      setModalNotif({
        tipo:'warning',
        titulo:'Producto duplicado',
        mensaje:`${prodSelec.producto} ya existe en el requerimiento. No se puede agregar dos veces el mismo producto.`
      });
      return;
    }
    setAgregando(true);
    try {
      const r = await api.post(`/farmacia/requerimiento/${cabecera.REQ_ID}/agregar-linea`, {
        medcod:        prodSelec.medcod,
        producto:      prodSelec.producto,
        cantPropuesta: parseFloat(cantAgregar),
        obs:           obsAgregar.trim(),
        saldo:         prodSelec.saldo,
      });
      if(r.data.success){
        setModalAgregar(false);
        setBuscarProd(''); setProdAlmacen([]); setProdSelec(null);
        setCantAgregar(''); setObsAgregar('');
        onRecargar();
        await cargarEvaluacion();
      }
    } catch(e){ console.error(e); } finally { setAgregando(false); }
  };

  const retrocederEstado = async () => {
    setProcesandoRet(true);
    try {
      const r = await api.put(`/farmacia/requerimiento/${cabecera.REQ_ID}/retroceder`, {
        usuario: user?.nombreCompleto || user?.usuario || ''
      });
      if(r.data.success){
        setModalRetroceder(false);
        setModalNotif({tipo:'success',titulo:'Estado retrocedido',mensaje:r.data.message});
        setModoEval(false);
        onRecargar();
      } else {
        setModalNotif({tipo:'error',titulo:'Error',mensaje:r.data.message});
      }
    } catch(e){ console.error(e); } finally { setProcesandoRet(false); }
  };

  const cancelarRequerimiento = async () => {
    if(!motivoCancelar.trim()) return;
    setProcesandoRet(true);
    try {
      const r = await api.put(`/farmacia/requerimiento/${cabecera.REQ_ID}/cancelar`, {
        usuario: user?.nombreCompleto || user?.usuario || '',
        motivo:  motivoCancelar.trim()
      });
      if(r.data.success){
        setModalCancelar(false);
        setMotivoCancelar('');
        onVolver();
        onCambiarEstado && onCambiarEstado();
      } else {
        setModalNotif({tipo:'error',titulo:'Error',mensaje:r.data.message});
      }
    } catch(e){ console.error(e); } finally { setProcesandoRet(false); }
  };

  const verGuiaPdf = async () => {
    try {
      const nombre = cabecera.REQ_PDF_GUIA?.split('/').pop();
      if(!nombre) return;
      const r = await api.get(`/farmacia/requerimiento/pdf-guia/${nombre}`, {responseType:'blob'});
      const url = window.URL.createObjectURL(new Blob([r.data],{type:'application/pdf'}));
      setPdfBlobUrl(url);
      setModalPdfGuia(true);
    } catch(e){ console.error(e); }
  };

  const cerrarModalPdfGuia = () => {
    setModalPdfGuia(false);
    if(pdfBlobUrl){ window.URL.revokeObjectURL(pdfBlobUrl); setPdfBlobUrl(null); }
  };

  const registrarRecojo = async () => {
    if(!fechaRecojo||!horaRecojo) return;
    // Validar día de semana
    const [fy,fm,fd] = fechaRecojo.split('-').map(Number);
    const diaSemana = new Date(fy,fm-1,fd).getDay(); // 0=dom, 6=sab
    if(diaSemana===0||diaSemana===6){
      setModalNotif({tipo:'error',titulo:'Día no válido',mensaje:'El recojo solo puede programarse de lunes a viernes.'});
      return;
    }
    const [hh,mm] = horaRecojo.split(':').map(Number);
    const minutos = hh*60+mm;
    if(minutos < 7*60 || minutos > 19*60){
      setModalNotif({tipo:'error',titulo:'Horario no válido',mensaje:'El recojo debe programarse entre las 7:00 AM y las 7:00 PM.'});
      return;
    }
    setGuardandoRecojo(true);
    try {
      const r = await api.post(`/farmacia/requerimiento/${cabecera.REQ_ID}/recojo`, {
        idIpress: cabecera.ID_IPRESS,
        fecha: fechaRecojo,
        hora: horaRecojo,
        registradoPor: user?.nombreCompleto || user?.usuario || ''
      });
      if(r.data.success){
        setModalRecojo(false);
        onRecargar();
        setModalNotif({
          tipo:'success',
          titulo:'Recojo confirmado',
          mensaje:`Tu recojo ha sido programado para el ${fechaRecojo} a las ${horaRecojo} hrs. El almacén fue notificado.`,
        });
      } else {
        setModalNotif({
          tipo:'error',
          titulo:'No se pudo programar',
          mensaje: r.data.message||'Ocurrió un error al registrar el recojo.',
        });
      }
    } catch(e){ console.error(e); } finally { setGuardandoRecojo(false); }
  };

  const ejecutarAccion = async () => {
    setProcesando(true);
    try {
      let extra = {};
      if(accion==='RECHAZADO')      extra = { mensaje };
      if(accion==='EN_PREPARACION'){
        const pdfPath = pdfFile ? await subirPdf() : null;
        extra = { nroGuia, ...(pdfPath?{pdfPath}:{}) };
      }
      if(accion==='LISTO') extra = { nroItems:parseInt(nroItems||0), nroBultos:parseInt(nroBultos||0), pesoKg:parseFloat(pesoKg||0) };
      await onCambiarEstado(cabecera.REQ_ID, accion, extra);
      setAccion(null);
      onRecargar();
    } finally { setProcesando(false); }
  };

  // acciones disponibles según estado y rol
  const accionesPosibles = () => {
    if(!esTOTAL) return [];
    const m = {
      ENVIADO:        [{label:'Marcar recibido',color:IOS.blue,  estado:'RECIBIDO'},     {label:'Rechazar',color:IOS.red,estado:'RECHAZADO'}],
      RECIBIDO:       [{label:'Iniciar evaluación',color:'#8B5CF6',estado:'EN_EVALUACION'}],
      EN_EVALUACION:  [
        {label:'Aprobar',color:IOS.green,estado:'APROBADO'},
        {label:'Rechazar',color:IOS.red,estado:'RECHAZADO'},
      ],
      EN_EVALUACION:  [{label:'Aprobar',color:IOS.green,estado:'APROBADO'},              {label:'Rechazar',color:IOS.red,estado:'RECHAZADO'}],
      APROBADO:       [{label:'Iniciar preparación',color:'#5E5CE6',estado:'EN_PREPARACION'}],
      EN_PREPARACION: [{label:'Marcar listo',color:'#059669',estado:'LISTO'}],
      LISTO:          cabecera.REQ_FECHA_RECOJO_PROG
        ? [{label:'Marcar entregado',color:IOS.label2,estado:'ENTREGADO'}]
        : [],
    };
    return m[cabecera.REQ_ESTADO] || [];
  };

  const pasos = ['ENVIADO','RECIBIDO','EN_EVALUACION','APROBADO','EN_PREPARACION','LISTO','ENTREGADO'];
  const idxActual = pasos.indexOf(cabecera.REQ_ESTADO);
const ModalNotif = () => {
    if(!modalNotif) return null;
    const cfgs = {
      success: { color:'#059669', bg:'#ECFDF5', border:'#A7F3D0', icon:
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>, icon2:<polyline points="22 4 12 14.01 9 11.01"/> },
      error:   { color:IOS.red,   bg:'#FFF0EF', border:'#FFD4D1', icon:
        <><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></> },
      warning: { color:IOS.orange,bg:'#FFF8E6', border:'#FFE9A0', icon:
        <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></> },
    };
    const cfg = cfgs[modalNotif.tipo]||cfgs.error;
    return(
      <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:99999,bgcolor:'rgba(0,0,0,0.45)',
        display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
        onClick={()=>setModalNotif(null)}>
        <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" onClick={e=>e.stopPropagation()}
          sx={{bgcolor:IOS.surface,borderRadius:'20px',overflow:'hidden',
            width:440,maxHeight:'80vh',boxShadow:'0 24px 60px rgba(0,0,0,0.2)',
            display:'flex',flexDirection:'column'}}>
          {/* Header */}
          <Box className="pharmacy-layout" sx={{px:3,pt:3,pb:2,display:'flex',alignItems:'flex-start',gap:1.5,
            borderBottom:modalNotif.items?.length>0?`1px solid ${IOS.separator}`:'none'}}>
            <Box className="pharmacy-layout" sx={{width:44,height:44,borderRadius:'12px',bgcolor:cfg.bg,
              border:`1px solid ${cfg.border}`,display:'flex',alignItems:'center',
              justifyContent:'center',flexShrink:0}}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke={cfg.color} strokeWidth="2" strokeLinecap="round">
                {cfg.icon}{cfg.icon2||null}
              </svg>
            </Box>
            <Box sx={{flex:1,pt:0.3}}>
              <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label,mb:0.3}}>
                {modalNotif.titulo}
              </Typography>
              <Typography sx={{fontSize:'0.78rem',color:IOS.label2,lineHeight:1.5}}>
                {modalNotif.mensaje}
              </Typography>
            </Box>
          </Box>
          {/* Tabla de items si hay */}
          {modalNotif.items?.length>0&&(
            <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{overflowY:'auto',maxHeight:300,
              '&::-webkit-scrollbar':{width:3},
              '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.72rem'}}>
                <thead>
                  <tr style={{backgroundColor:IOS.bg}}>
                    {(modalNotif.cols||['Producto','Propuesto','Stock']).map((c,i)=>(
                      <th key={i} style={{padding:'8px 14px',textAlign:i>0?'right':'left',
                        fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                        letterSpacing:'0.06em',textTransform:'uppercase',
                        borderBottom:`1px solid ${IOS.separator}`}}>{c}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {modalNotif.items.map((item,i)=>(
                    <tr key={i} style={{borderBottom:`1px solid ${IOS.separator}`}}
                      onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                      onMouseLeave={e=>e.currentTarget.style.backgroundColor='transparent'}>
                      {item.map((cell,j)=>(
                        <td key={j} style={{padding:'8px 14px',textAlign:j>0?'right':'left',
                          color:j===item.length-1&&parseFloat(cell)===0?IOS.red:
                                j===item.length-2&&parseFloat(cell)>parseFloat(item[item.length-1])?IOS.orange:IOS.label,
                          fontWeight:j>0?600:400}}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          )}
          {/* Footer */}
          <Box className="pharmacy-layout" sx={{px:3,py:2,display:'flex',justifyContent:'flex-end',
            borderTop:modalNotif.items?.length>0?`1px solid ${IOS.separator}`:'none'}}>
            <Box className="pharmacy-action" component="button" onClick={()=>setModalNotif(null)}
              sx={{height:36,px:2.5,borderRadius:'10px',border:'none',
                bgcolor:cfg.color,cursor:'pointer',fontSize:'0.82rem',
                fontWeight:700,color:'white',transition:'all 0.15s',
                '&:hover':{filter:'brightness(0.9)'}}}>
              Entendido
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };
 return (
    <Box>
      <ModalNotif/>
      {/* Modal retroceder */}
      {modalRetroceder&&(
        <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',
          display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onClick={()=>!procesandoRet&&setModalRetroceder(false)}>
          <Box className="pharmacy-modal-panel pharmacy-card" onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:400,
              boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.5,mb:2}}>
              <Box className="pharmacy-layout" sx={{width:44,height:44,borderRadius:'12px',bgcolor:'#FFF8E6',
                border:'1px solid #FFE9A0',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2" strokeLinecap="round">
                  <polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/>
                </svg>
              </Box>
              <Box>
                <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label}}>
                  Retroceder estado
                </Typography>
                <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
                  {cabecera.REQ_NUMERO} — Estado actual: {estados[cabecera.REQ_ESTADO]?.label||cabecera.REQ_ESTADO}
                </Typography>
              </Box>
            </Box>
            <Box sx={{p:1.5,bgcolor:'#FFF8E6',borderRadius:'10px',border:'1px solid #FFE9A0',mb:2}}>
              <Typography sx={{fontSize:'0.78rem',color:'#8B6914',lineHeight:1.5}}>
                El requerimiento volverá al estado anterior. Esta acción es reversible pero quedará registrada en el sistema.
              </Typography>
            </Box>
            <Box className="pharmacy-layout" sx={{display:'flex',gap:1}}>
              <Box className="pharmacy-action" component="button" onClick={()=>setModalRetroceder(false)} disabled={procesandoRet}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Cancelar
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={retrocederEstado} disabled={procesandoRet}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',bgcolor:IOS.orange,
                  cursor:'pointer',fontSize:'0.82rem',fontWeight:700,color:'white',
                  display:'flex',alignItems:'center',justifyContent:'center',gap:0.8,
                  transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                {procesandoRet?<CircularProgress size={14} sx={{color:'white'}}/>:null}
                {procesandoRet?'Procesando...':'Confirmar'}
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Modal cancelar */}
      {modalCancelar&&(
        <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',
          display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onClick={()=>!procesandoRet&&setModalCancelar(false)}>
          <Box className="pharmacy-modal-panel pharmacy-card" onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:420,
              boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.5,mb:2}}>
              <Box className="pharmacy-layout" sx={{width:44,height:44,borderRadius:'12px',bgcolor:'#FFF0EF',
                border:'1px solid #FFD4D1',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="15" y1="9" x2="9" y2="15"/>
                  <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
              </Box>
              <Box>
                <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label}}>
                  Cancelar requerimiento
                </Typography>
                <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
                  {cabecera.REQ_NUMERO} — Esta acción no se puede deshacer
                </Typography>
              </Box>
            </Box>
            <Box sx={{mb:2}}>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                textTransform:'uppercase',letterSpacing:'0.06em',mb:0.5}}>
                Motivo de cancelación <span style={{color:IOS.red}}>*</span>
              </Typography>
              <textarea value={motivoCancelar} onChange={e=>setMotivoCancelar(e.target.value)}
                rows={3} placeholder="Indica el motivo por el que se cancela este requerimiento..."
                style={{width:'100%',padding:'8px 12px',
                  border:`1px solid ${motivoCancelar.trim()?IOS.separator:IOS.red}`,
                  borderRadius:8,fontSize:'0.78rem',color:IOS.label,backgroundColor:IOS.bg,
                  outline:'none',fontFamily:'inherit',resize:'vertical',boxSizing:'border-box'}}
                onFocus={e=>e.target.style.borderColor=IOS.blue}
                onBlur={e=>e.target.style.borderColor=motivoCancelar.trim()?IOS.separator:IOS.red}/>
            </Box>
            <Box className="pharmacy-layout" sx={{display:'flex',gap:1}}>
              <Box className="pharmacy-action" component="button" onClick={()=>{setModalCancelar(false);setMotivoCancelar('');}}
                disabled={procesandoRet}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Volver
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cancelarRequerimiento}
                disabled={procesandoRet||!motivoCancelar.trim()}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',bgcolor:IOS.red,
                  cursor:'pointer',fontSize:'0.82rem',fontWeight:700,color:'white',
                  display:'flex',alignItems:'center',justifyContent:'center',gap:0.8,
                  opacity:!motivoCancelar.trim()?0.5:1,
                  transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                {procesandoRet?<CircularProgress size={14} sx={{color:'white'}}/>:null}
                {procesandoRet?'Cancelando...':'Cancelar requerimiento'}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {modalAgregar&&(
        <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',
          display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onMouseDown={e=>{ if(e.target===e.currentTarget&&!agregando) setModalAgregar(false); }}>
          <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:480,
              boxShadow:'0 24px 60px rgba(0,0,0,0.2)',display:'flex',flexDirection:'column',gap:2}}>

            {/* Header */}
            <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <Box>
                <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label}}>
                  Agregar producto
                </Typography>
                <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
                  La observación es obligatoria para productos adicionales
                </Typography>
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalAgregar(false)}
                sx={{width:30,height:30,borderRadius:'50%',border:'none',bgcolor:'#E5E5EA',
                  cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round">
                  <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
              </Box>
            </Box>

            {/* Buscador */}
            <Box>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                textTransform:'uppercase',letterSpacing:'0.06em',mb:0.5}}>
                Buscar producto (mín. 3 caracteres)
              </Typography>
              <Box sx={{position:'relative'}}>
                <Box sx={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',
                  pointerEvents:'none'}}>
                  {loadProd
                    ?<CircularProgress size={12} sx={{color:IOS.label2}}/>
                    :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
                      <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
                    </svg>}
                </Box>
                <input type="text" value={buscarProd}
                  onChange={e=>buscarProductos(e.target.value)}
                  placeholder="Código o nombre del producto..."
                  style={{width:'100%',height:36,paddingLeft:30,paddingRight:10,
                    border:`1px solid ${IOS.separator}`,borderRadius:8,fontSize:'0.82rem',
                    color:IOS.label,backgroundColor:IOS.bg,outline:'none',
                    fontFamily:'inherit',boxSizing:'border-box'}}
                  onFocus={e=>e.target.style.borderColor=IOS.blue}
                  onBlur={e=>e.target.style.borderColor=IOS.separator}/>
              </Box>
            </Box>

            {/* Lista resultados */}
            {prodAlmacen.length>0&&!prodSelec&&(
              <Box sx={{maxHeight:200,overflowY:'auto',border:`1px solid ${IOS.separator}`,
                borderRadius:'10px',overflow:'hidden',
                '&::-webkit-scrollbar':{width:3},
                '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                {prodAlmacen.map((p,i)=>(
                  <Box className="pharmacy-layout" key={p.medcod} onClick={()=>{setProdSelec(p);setProdAlmacen([]);}}
                    sx={{px:1.5,py:1,cursor:'pointer',
                      borderBottom:i<prodAlmacen.length-1?`1px solid ${IOS.separator}`:'none',
                      display:'flex',alignItems:'center',justifyContent:'space-between',
                      '&:hover':{bgcolor:IOS.bg}}}>
                    <Box sx={{flex:1,minWidth:0}}>
                      <Typography sx={{fontSize:'0.72rem',fontWeight:600,color:IOS.label,
                        overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                        {p.producto}
                      </Typography>
                      <Typography sx={{fontSize: '0.72rem',color:IOS.label2,fontFamily:'monospace'}}>
                        {p.medcod}
                      </Typography>
                    </Box>
                    <Box sx={{ml:1,px:0.8,py:0.3,borderRadius:'20px',
                      bgcolor:'#ECFDF5',border:'1px solid #A7F3D0',flexShrink:0}}>
                      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:'#059669'}}>
                        {parseFloat(p.saldo).toLocaleString()} und.
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            {/* Producto seleccionado */}
            {prodSelec&&(
              <Box className="pharmacy-layout" sx={{p:1.5,bgcolor:`${IOS.blue}08`,borderRadius:'10px',
                border:`1px solid ${IOS.blue}20`,display:'flex',alignItems:'center',gap:1}}>
                <Box sx={{flex:1,minWidth:0}}>
                  <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:IOS.label,
                    overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                    {prodSelec.producto}
                  </Typography>
                  <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>
                    {prodSelec.medcod} · Stock: {parseFloat(prodSelec.saldo).toLocaleString()} und.
                  </Typography>
                </Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>{setProdSelec(null);setBuscarProd('');}}
                  sx={{width:24,height:24,borderRadius:'50%',border:'none',
                    bgcolor:'#E5E5EA',cursor:'pointer',display:'flex',
                    alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round">
                    <path d="M18 6L6 18M6 6l12 12"/>
                  </svg>
                </Box>
              </Box>
            )}

            {/* Cantidad y observación */}
            {prodSelec&&(
              <Box className="pharmacy-layout" sx={{display:'flex',flexDirection:'column',gap:1.5}}>
                <Box>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                    textTransform:'uppercase',letterSpacing:'0.06em',mb:0.5}}>
                    Cantidad a proponer
                  </Typography>
                  <input type="number" min="1"
                    max={prodSelec.saldo}
                    value={cantAgregar}
                    onChange={e=>setCantAgregar(e.target.value)}
                    placeholder="0"
                    style={{width:'100%',height:36,padding:'0 12px',
                      border:`1px solid ${IOS.separator}`,borderRadius:8,fontSize:'0.82rem',
                      color:IOS.label,backgroundColor:IOS.bg,outline:'none',
                      fontFamily:'inherit',boxSizing:'border-box'}}
                    onFocus={e=>e.target.style.borderColor=IOS.blue}
                    onBlur={e=>e.target.style.borderColor=IOS.separator}/>
                  {parseFloat(cantAgregar||0)>parseFloat(prodSelec.saldo)&&(
                    <Typography sx={{fontSize: '0.72rem',color:IOS.red,mt:0.4}}>
                      Supera el stock disponible ({parseFloat(prodSelec.saldo).toLocaleString()} und.)
                    </Typography>
                  )}
                </Box>
                <Box>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                    textTransform:'uppercase',letterSpacing:'0.06em',mb:0.5}}>
                    Motivo / Observación <span style={{color:IOS.red}}>*</span>
                  </Typography>
                  <textarea value={obsAgregar} onChange={e=>setObsAgregar(e.target.value)}
                    rows={3} placeholder="Indica el motivo por el que se agrega este producto adicional..."
                    style={{width:'100%',padding:'8px 12px',border:`1px solid ${obsAgregar.trim()?IOS.separator:IOS.red}`,
                      borderRadius:8,fontSize:'0.78rem',color:IOS.label,backgroundColor:IOS.bg,
                      outline:'none',fontFamily:'inherit',resize:'vertical',boxSizing:'border-box'}}
                    onFocus={e=>e.target.style.borderColor=IOS.blue}
                    onBlur={e=>e.target.style.borderColor=obsAgregar.trim()?IOS.separator:IOS.red}/>
                </Box>
              </Box>
            )}

            {/* Botones */}
            <Box className="pharmacy-layout" sx={{display:'flex',gap:1}}>
              <Box className="pharmacy-action" component="button" onClick={()=>setModalAgregar(false)} disabled={agregando}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Cancelar
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={agregarLinea}
                disabled={agregando||!prodSelec||!cantAgregar||!obsAgregar.trim()||
                  parseFloat(cantAgregar||0)>parseFloat(prodSelec?.saldo||0)}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',
                  bgcolor:IOS.blue,cursor:'pointer',fontSize:'0.82rem',fontWeight:700,
                  color:'white',display:'flex',alignItems:'center',justifyContent:'center',gap:0.8,
                  opacity:!prodSelec||!cantAgregar||!obsAgregar.trim()?0.5:1,
                  transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                {agregando?<CircularProgress size={14} sx={{color:'white'}}/>:null}
                {agregando?'Agregando...':'Confirmar'}
              </Box>
            </Box>

          </Box>
        </Box>
      )}
      {modalPdfGuia&&pdfBlobUrl&&(
        <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.8)',
          display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}
          onClick={cerrarModalPdfGuia}>
          <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" onClick={e=>e.stopPropagation()}
            sx={{width:'90vw',height:'90vh',bgcolor:IOS.surface,borderRadius:'16px',
              overflow:'hidden',display:'flex',flexDirection:'column',
              boxShadow:'0 24px 60px rgba(0,0,0,0.4)'}}>
            <Box className="pharmacy-layout" sx={{px:2.5,py:1.5,borderBottom:`1px solid ${IOS.separator}`,
              display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1}}>
                <Box className="pharmacy-layout" sx={{width:32,height:32,borderRadius:'8px',bgcolor:'#FFF0EF',
                  display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                  </svg>
                </Box>
                <Box>
                  <Typography sx={{fontSize:'0.88rem',fontWeight:700,color:IOS.label}}>
                    Guía SISMED
                  </Typography>
                  <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>
                    {cabecera.REQ_NRO_GUIA_SISMED||''} · {cabecera.REQ_NUMERO}
                  </Typography>
                </Box>
              </Box>
              <Box className="pharmacy-layout" sx={{display:'flex',gap:1}}>
                <Box className="pharmacy-layout pharmacy-action" component="button"
                  onClick={async()=>{
                    const a = document.createElement('a');
                    a.href = pdfBlobUrl;
                    a.download = `Guia_${cabecera.REQ_NUMERO}.pdf`;
                    a.click();
                  }}
                  sx={{height:32,px:1.5,borderRadius:'8px',border:`1px solid ${IOS.separator}`,
                    bgcolor:IOS.bg,cursor:'pointer',display:'flex',alignItems:'center',gap:0.6,
                    transition:'all 0.15s','&:hover':{bgcolor:IOS.separator}}}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
                    <path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/>
                  </svg>
                  <Typography sx={{fontSize:'0.72rem',color:IOS.label2,fontWeight:600}}>Descargar</Typography>
                </Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cerrarModalPdfGuia}
                  sx={{width:32,height:32,borderRadius:'50%',border:'none',bgcolor:'#E5E5EA',
                    cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',
                    transition:'all 0.15s','&:hover':{bgcolor:'#D1D1D6'}}}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round">
                    <path d="M18 6L6 18M6 6l12 12"/>
                  </svg>
                </Box>
              </Box>
            </Box>
            <Box sx={{flex:1,overflow:'hidden',bgcolor:'#525659'}}>
              <iframe
                src={pdfBlobUrl}
                style={{width:'100%',height:'100%',border:'none'}}
                title="Guía SISMED"
              />
            </Box>
          </Box>
        </Box>
      )}
      {/* Header */}
      <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.5,mb:2.5}}>
        <Box className="pharmacy-layout pharmacy-action" component="button" onClick={onVolver}
          sx={{width:34,height:34,borderRadius:'50%',border:`1px solid ${IOS.separator}`,
            bgcolor:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',
            transition:'all 0.15s','&:hover':{bgcolor:IOS.bg}}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2" strokeLinecap="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </Box>
        <Box sx={{flex:1}}>
          <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.2}}>
            <Typography sx={{fontSize:'1.4rem',fontWeight:800,color:IOS.blue,
              fontFamily:'ui-monospace,monospace',letterSpacing:'-0.02em'}}>
              {cabecera.REQ_NUMERO}
            </Typography>
            <Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:1,py:0.3,
              borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`}}>
              <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:cfg.dot}}/>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text}}>{cfg.label}</Typography>
            </Box>
          </Box>
          <Typography sx={{fontSize:'0.78rem',color:IOS.label2}}>
            {cabecera.NOMBRE_IPRESS} → {cabecera.NOMBRE_ALMACEN} · {cabecera.REQ_MESES} mes(es) · {cabecera.REQ_TIPO==='C'?'Completo':'Med. Esenciales'}
          </Typography>
        </Box>
        <Box className="pharmacy-layout" sx={{display:'flex',gap:1,flexWrap:'wrap'}}>
          {cabecera.REQ_ESTADO==='EN_EVALUACION'&&esTOTAL&&(
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={modoEval?()=>setModoEval(false):cargarEvaluacion}
              disabled={loadEval}
              sx={{height:34,px:2,borderRadius:'10px',border:`1px solid ${IOS.separator}`,
                bgcolor:modoEval?IOS.bg:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{bgcolor:IOS.bg}}}>
              {loadEval?<CircularProgress size={13} sx={{color:IOS.blue}}/>
                :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>}
              <Typography sx={{fontSize:'0.78rem',fontWeight:600,color:IOS.blue}}>
                {modoEval?'Cancelar edición':'Evaluar requerimiento'}
              </Typography>
            </Box>
          )}
          {(['APROBADO','EN_PREPARACION','LISTO','ENTREGADO'].includes(cabecera.REQ_ESTADO)
            || (!esTOTAL && !['CANCELADO'].includes(cabecera.REQ_ESTADO)))&&(
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={imprimirRequerimiento}
              disabled={imprimiendo}
              sx={{height:34,px:2,borderRadius:'10px',border:'none',
                bgcolor:'#EF4444',cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s',opacity:imprimiendo?0.7:1,
                '&:hover':{filter:'brightness(0.9)'}}}>
              {imprimiendo
                ?<CircularProgress size={13} sx={{color:'white'}}/>
                :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                </svg>}
              <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:'white'}}>
                {imprimiendo?'Generando...'
                  :['APROBADO','EN_PREPARACION','LISTO','ENTREGADO'].includes(cabecera.REQ_ESTADO)
                    ?'Exportar PDF':'PDF preliminar'}
              </Typography>
            </Box>
          )}
          {esTOTAL&&!['ENTREGADO','CANCELADO','ENVIADO','RECIBIDO','EN_EVALUACION','APROBADO','EN_PREPARACION'].includes(cabecera.REQ_ESTADO)&&(
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>{setFechaRecojo('');setHoraRecojo('');setModalRecojo(true);}}
              sx={{height:34,px:2,borderRadius:'10px',border:'none',
                bgcolor:'#059669',cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{filter:'brightness(0.9)'}}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:'white'}}>Programar recojo</Typography>
            </Box>
          )}

          {esTOTAL&&cabecera.REQ_ESTADO!=='ENVIADO'&&cabecera.REQ_ESTADO!=='ENTREGADO'&&cabecera.REQ_ESTADO!=='CANCELADO'&&(
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalRetroceder(true)}
              sx={{height:34,px:2,borderRadius:'10px',border:`1px solid ${IOS.separator}`,
                bgcolor:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{bgcolor:'#FFF8E6',borderColor:'#FFE9A0'}}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2" strokeLinecap="round">
                <polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/>
              </svg>
              <Typography sx={{fontSize:'0.78rem',fontWeight:600,color:IOS.orange}}>
                Retroceder
              </Typography>
            </Box>
          )}
          {esTOTAL&&cabecera.REQ_ESTADO!=='ENTREGADO'&&cabecera.REQ_ESTADO!=='CANCELADO'&&(
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalCancelar(true)}
              sx={{height:34,px:2,borderRadius:'10px',border:`1px solid #FFD4D1`,
                bgcolor:'#FFF0EF',cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{bgcolor:'#FFD4D1'}}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              <Typography sx={{fontSize:'0.78rem',fontWeight:600,color:IOS.red}}>
                Cancelar
              </Typography>
            </Box>
          )}
          
          {accionesPosibles().map(({label,color,estado})=>(
            <Box className="pharmacy-layout pharmacy-action" key={estado} component="button" onClick={()=>setAccion(estado)}
              sx={{height:34,px:2,borderRadius:'10px',border:'none',cursor:'pointer',
                bgcolor:color,display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{filter:'brightness(0.9)'}}}>
              <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:'white'}}>{label}</Typography>
            </Box>
          ))}
          {cabecera.REQ_ESTADO==='LISTO'&&!cabecera.REQ_FECHA_RECOJO_PROG&&(
            <Box className="pharmacy-layout" sx={{height:34,px:1.5,borderRadius:'10px',bgcolor:'#FFF8E6',
              border:'1px solid #FFE9A0',display:'flex',alignItems:'center',gap:0.6}}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2" strokeLinecap="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              <Typography sx={{fontSize:'0.7rem',fontWeight:600,color:'#8B6914'}}>
                Falta programar recojo
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Progreso */}
      {cabecera.REQ_ESTADO!=='RECHAZADO'&&(
        <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2.5,mb:2,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
          <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:1.5}}>
            {pasos.map((p,i)=>{
              const c = estados[p] || {label:p,dot:IOS.separator,text:IOS.label2};
              const activo = i===idxActual;
              const pasado = i<idxActual;
              return(
                <Box className="pharmacy-layout" key={p} sx={{display:'flex',flexDirection:'column',alignItems:'center',gap:0.5,flex:1,position:'relative'}}>
                  {i>0&&<Box sx={{position:'absolute',top:10,right:'50%',left:'-50%',height:2,
                    bgcolor:pasado||activo?cfg.dot:IOS.separator,transition:'background 0.3s'}}/>}
                  <Box className="pharmacy-layout" sx={{width:20,height:20,borderRadius:'50%',zIndex:1,
                    bgcolor:activo?cfg.dot:pasado?cfg.dot:'transparent',
                    border:`2px solid ${activo||pasado?cfg.dot:IOS.separator}`,
                    display:'flex',alignItems:'center',justifyContent:'center',
                    transition:'all 0.3s'}}>
                    {pasado&&<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>}
                  </Box>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:activo?700:400,
                    color:activo?cfg.text:pasado?cfg.dot:IOS.label3,textAlign:'center',lineHeight:1.2,
                    whiteSpace:'nowrap'}}>{c.label}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}

      {/* Info cabecera */}
      <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr',sm:'1fr 1fr',md:'repeat(4,1fr)'},gap:1.5,mb:2}}>
        {[
          {label:'Enviado por',   value:cabecera.REQ_ENVIADO_POR||'—'},
          {label:'Fecha envío',   value:cabecera.REQ_FECHA_ENVIO?new Date(cabecera.REQ_FECHA_ENVIO).toLocaleDateString('es-PE'):'—'},
          {label:'Recibido por',  value:cabecera.REQ_RECIBIDO_POR||'—'},
          {label:'Evaluado por',  value:cabecera.REQ_EVALUADO_POR||'—'},
          {label:'Aprobado por',  value:cabecera.REQ_APROBADO_POR||'—'},
          {label:'Nro. Guía SISMED', value:cabecera.REQ_NRO_GUIA_SISMED||'—'},
          {label:'Items / Bultos', value:cabecera.REQ_NRO_ITEMS?(cabecera.REQ_NRO_ITEMS+' items · '+cabecera.REQ_NRO_BULTOS+' bultos · '+cabecera.REQ_PESO_KG+' kg'):'—'},
          {label:'Recojo programado', value:cabecera.REQ_FECHA_RECOJO_PROG?(
            new Date(cabecera.REQ_FECHA_RECOJO_PROG).toLocaleDateString('es-PE')+
            ' — '+(String(cabecera.REQ_HORA_RECOJO_PROG||'').substring(0,5))
          ):null},
          {label:'Rechazado por', value:cabecera.REQ_RECHAZADO_POR?`${cabecera.REQ_RECHAZADO_POR}: ${cabecera.REQ_MENSAJE_RECHAZO||''}`:null},
        ].filter(x=>x.value&&x.value!=='—'&&x.value!==null).map(({label,value})=>(
          <Box key={label} sx={{bgcolor:IOS.surface,borderRadius:'12px',p:1.5,
            border:`1px solid ${IOS.separator}`}}>
            <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
              letterSpacing:'0.06em',textTransform:'uppercase',mb:0.4}}>{label}</Typography>
            <Typography sx={{fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>{value}</Typography>
          </Box>
          
        ))}
        {cabecera.REQ_FECHA_RECOJO_PROG&&(
          <Box sx={{bgcolor:'#ECFDF5',borderRadius:'12px',p:1.5,
            border:'1px solid #A7F3D0',gridColumn:{md:'span 2'}}}>
            <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:0.6,mb:0.4}}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#065F46" strokeWidth="2" strokeLinecap="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:'#065F46',
                letterSpacing:'0.06em',textTransform:'uppercase'}}>
                Recojo programado por IPRESS
              </Typography>
            </Box>
            <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:'#059669'}}>
              {new Date(cabecera.REQ_FECHA_RECOJO_PROG).toLocaleDateString('es-PE',{weekday:'long',day:'2-digit',month:'long',year:'numeric'})}
              {' — '}{String(cabecera.REQ_HORA_RECOJO_PROG||'').substring(0,5)} hrs
            </Typography>
          </Box>
        )}
        {cabecera.REQ_PDF_GUIA&&(
          <Box className="pharmacy-layout" sx={{bgcolor:IOS.surface,borderRadius:'12px',p:1.5,border:`1px solid ${IOS.separator}`,
            display:'flex',alignItems:'center',gap:1,cursor:'pointer',
            '&:hover':{bgcolor:IOS.bg}}}
            onClick={verGuiaPdf}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
            <Box>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.06em'}}>PDF Guía</Typography>
              <Typography sx={{fontSize:'0.72rem',fontWeight:600,color:IOS.red}}>Ver documento</Typography>
            </Box>
          </Box>
        )}
      </Box>

      {/* Modo evaluación */}
      {modoEval&&(
        <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',mb:2,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.blue}40`,overflow:'hidden'}}>
          <Box className="pharmacy-layout" sx={{px:2.5,py:1.5,borderBottom:`1px solid ${IOS.separator}`,
            display:'flex',alignItems:'center',justifyContent:'space-between',
            bgcolor:`${IOS.blue}06`}}>
            <Box>
              <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.blue}}>
                Modo evaluación
              </Typography>
              <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>
                Edita la cantidad a proponer. La columna "Sugerido" es el mínimo entre lo solicitado y el stock actual del almacén.
              </Typography>
            </Box>



            <Box className="pharmacy-layout" sx={{display:'flex',gap:1,alignItems:'center'}}>
              {lineasEval.filter(l=>parseFloat(l.STOCK_ACTUAL_ALMACEN||l.STOCK_ALMACEN||0)===0).length>0&&(
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={marcarSinStock}
                  sx={{height:34,px:2,borderRadius:'10px',border:`1px solid ${IOS.red}40`,
                    bgcolor:'#FFF0EF',cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                    transition:'all 0.2s','&:hover':{bgcolor:'#FFD4D1'}}}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                  <Typography sx={{fontSize:'0.78rem',fontWeight:600,color:IOS.red}}>
                    Ocultar sin stock ({lineasEval.filter(l=>parseFloat(l.STOCK_ACTUAL_ALMACEN||l.STOCK_ALMACEN||0)===0).length})
                  </Typography>
                </Box>
              )}
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalAgregar(true)}
              sx={{height:34,px:2,borderRadius:'10px',border:`1px solid ${IOS.blue}`,
                bgcolor:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{bgcolor:`${IOS.blue}08`}}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              <Typography sx={{fontSize:'0.78rem',fontWeight:600,color:IOS.blue}}>
                Agregar producto
              </Typography>
            </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={guardarEvaluacion} disabled={guardandoEval}
              sx={{height:34,px:2,borderRadius:'10px',border:'none',bgcolor:IOS.blue,
                cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
              {guardandoEval?<CircularProgress size={13} sx={{color:'white'}}/>
                :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                  <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
                </svg>}
              <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:'white'}}>
                {guardandoEval?'Guardando...':'Guardar evaluación'}
              </Typography>
            </Box>
            </Box>

          </Box>
          <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{overflowX:'auto',overflowY:'auto',maxHeight:'55vh',
            '&::-webkit-scrollbar':{width:4,height:4},
            '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.75rem',minWidth:1000}}>
              <thead>
                <tr>
                  {['Código','Producto','Indicador','Stk IPRESS','CPMA','MSD','Solicitado','Stk Almacén','Sugerido','Proponer','Observación'].map((h,i)=>(
                      <th key={i} style={{padding:'9px 10px',textAlign:i>=3&&i<=9?'right':'left',
                      fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.06em',
                      textTransform:'uppercase',backgroundColor:`${IOS.blue}06`,
                      borderBottom:`1px solid ${IOS.separator}`,position:'sticky',top:0,whiteSpace:'nowrap',zIndex:1,
                    backdropFilter:'blur(8px)',WebkitBackdropFilter:'blur(8px)'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {lineasEval.map((l,i)=>{
                  const sol = parseFloat(l.CANT_SOLICITADA||0);
                  const sug = parseFloat(l.CANT_SUGERIDA||0);
                  const stk = parseFloat(l.STOCK_ACTUAL_ALMACEN||l.STOCK_ALMACEN||0);
                  const prop = parseFloat(l._propuesta||0);
                  const indCfg = IND_CFG[l.INDICADOR?.toUpperCase()] || {bg:IOS.bg,border:IOS.separator,text:IOS.label2,dot:IOS.label3};
                  const colorProp = prop===0?IOS.label2:prop<sol?IOS.orange:IOS.green;
                  return(
                    <tr key={l.DET_ID} style={{
                      borderBottom:`1px solid ${IOS.separator}`,
                      backgroundColor:stk===0?'#FFF0EF':'transparent'
                    }}
                      onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                      onMouseLeave={e=>e.currentTarget.style.backgroundColor=stk===0?'#FFF0EF':'transparent'}>
                      <td style={{padding:'8px 10px',fontFamily:'monospace',color:IOS.label2,fontSize:'0.7rem'}}>{l.MEDCOD}</td>
                      <td style={{padding:'8px 10px',maxWidth:220}}>
                        <span style={{display:'block',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:IOS.label}}>{l.PRODUCTO}</span>
                      </td>
                      <td style={{padding:'8px 10px'}}>
                        <Box sx={{display:'inline-flex',alignItems:'center',gap:0.4,px:0.7,py:0.2,
                          borderRadius:'20px',bgcolor:indCfg.bg,border:`1px solid ${indCfg.border}`}}>
                          <Box sx={{width:4,height:4,borderRadius:'50%',bgcolor:indCfg.dot}}/>
                          <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:indCfg.text}}>{l.INDICADOR||'—'}</Typography>
                        </Box>
                      </td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.STOCK_IPRESS||0).toFixed(0)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.CPMA||0).toFixed(2)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.MSD||0).toFixed(2)}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:IOS.blue}}>{sol.toLocaleString()}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:stk===0?IOS.red:IOS.green,fontWeight:600}}>{stk.toLocaleString()}</td>
                      <td style={{padding:'8px 10px',textAlign:'right',color:sug===0?IOS.red:IOS.orange,fontWeight:600}}>{sug.toLocaleString()}</td>
                      <td style={{padding:'4px 8px',textAlign:'right'}}>
                        <input type="number" min="0" value={l._propuesta}
                          onChange={e=>setLineasEval(prev=>prev.map(x=>x.DET_ID===l.DET_ID?{...x,_propuesta:e.target.value}:x))}
                          style={{width:80,textAlign:'right',border:`1px solid ${prop>0?`${IOS.blue}50`:IOS.separator}`,
                            borderRadius:8,padding:'4px 8px',fontSize:'0.78rem',fontWeight:prop>0?700:400,
                            color:colorProp,background:IOS.surface,outline:'none',fontFamily:'inherit'}}
                          onFocus={e=>e.target.style.borderColor=IOS.blue}
                          onBlur={e=>e.target.style.borderColor=parseFloat(e.target.value||0)>0?`${IOS.blue}50`:IOS.separator}/>
                      </td>
                      <td style={{padding:'4px 8px'}}>
                        <input type="text" value={l._obs} placeholder="Observación..."
                          onChange={e=>setLineasEval(prev=>prev.map(x=>x.DET_ID===l.DET_ID?{...x,_obs:e.target.value}:x))}
                          style={{width:'100%',minWidth:140,border:`1px solid ${IOS.separator}`,
                            borderRadius:8,padding:'4px 8px',fontSize:'0.72rem',
                            color:IOS.label,background:IOS.surface,outline:'none',fontFamily:'inherit'}}
                          onFocus={e=>e.target.style.borderColor=IOS.blue}
                          onBlur={e=>e.target.style.borderColor=IOS.separator}/>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{backgroundColor:IOS.bg,borderTop:`2px solid ${IOS.separator}`}}>
                  <td colSpan={6} style={{padding:'9px 10px',fontSize: '0.72rem',fontWeight:700,color:IOS.label2}}>
                    TOTALES — {lineasEval.length} productos
                  </td>
                  <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:IOS.blue,fontSize:'0.82rem'}}>
                    {lineasEval.reduce((s,l)=>s+parseFloat(l.CANT_SOLICITADA||0),0).toLocaleString()}
                  </td>
                  <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:IOS.green,fontSize:'0.82rem'}}>
                    {lineasEval.reduce((s,l)=>s+parseFloat(l.STOCK_ACTUAL_ALMACEN||0),0).toLocaleString()}
                  </td>
                  <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:IOS.orange,fontSize:'0.82rem'}}>
                    {lineasEval.reduce((s,l)=>s+parseFloat(l.CANT_SUGERIDA||0),0).toLocaleString()}
                  </td>
                  <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:IOS.blue,fontSize:'0.82rem'}}>
                    {lineasEval.reduce((s,l)=>s+parseFloat(l._propuesta||0),0).toLocaleString()}
                  </td>
                  <td/>
                </tr>
              </tfoot>
            </table>
          </Box>
        </Box>
      )}

      {/* Tabla líneas */}
      {!modoEval&&<Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',
        boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,overflow:'hidden'}}>
        <Box className="pharmacy-layout" sx={{px:2.5,py:1.5,borderBottom:`1px solid ${IOS.separator}`,
          display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label}}>
            Detalle — {lineas.length} productos
          </Typography>
          <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>
            Total solicitado: <strong>{lineas.reduce((s,l)=>s+parseFloat(l.CANT_SOLICITADA||0),0).toLocaleString()}</strong> unidades
          </Typography>
        </Box>
        <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{overflowX:'auto',maxHeight:'50vh',
          '&::-webkit-scrollbar':{width:4,height:4},
          '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.75rem',minWidth:900}}>
            <thead>
              <tr>
                {['Código','Producto','Indicador','Stk IPRESS','CPMA','MSD','Cons. Est.','Solicitado','Propuesto','Aprobado'].map((h,i)=>(
                  <th key={i} style={{padding:'9px 10px',textAlign:i>=3?'right':'left',
                    fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.06em',
                    textTransform:'uppercase',backgroundColor:IOS.surface,
                    borderBottom:`1px solid ${IOS.separator}`,position:'sticky',top:0,whiteSpace:'nowrap',zIndex:1}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lineas.map((l,i)=>{
                const solicitado = parseFloat(l.CANT_SOLICITADA||0);
                const propuesto  = parseFloat(l.CANT_PROPUESTA||0);
                const aprobado   = parseFloat(l.CANT_APROBADA||0);
                const diffPct    = propuesto>0&&solicitado>0 ? Math.round(((propuesto-solicitado)/solicitado)*100) : null;
                const indCfg = IND_CFG[l.INDICADOR?.toUpperCase()] || {bg:IOS.bg,border:IOS.separator,text:IOS.label2,dot:IOS.label3};
                return(
                  <tr key={l.DET_ID} style={{borderBottom:`1px solid ${IOS.separator}`,transition:'background 0.1s'}}
                    onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                    onMouseLeave={e=>e.currentTarget.style.backgroundColor='transparent'}>
                    <td style={{padding:'8px 10px',fontFamily:'monospace',color:IOS.label2,fontSize:'0.7rem'}}>{l.MEDCOD}</td>
                    <td style={{padding:'8px 10px',maxWidth:240}}>
                      <span style={{display:'block',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:IOS.label}}>{l.PRODUCTO}</span>
                    </td>
                    <td style={{padding:'8px 10px'}}>
                      <Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:0.8,py:0.2,
                        borderRadius:'20px',bgcolor:indCfg.bg,border:`1px solid ${indCfg.border}`}}>
                        <Box sx={{width:4,height:4,borderRadius:'50%',bgcolor:indCfg.dot}}/>
                        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:indCfg.text}}>{l.INDICADOR||'—'}</Typography>
                      </Box>
                    </td>
                    <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.STOCK_IPRESS||0).toFixed(0)}</td>
                    <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.CPMA||0).toFixed(2)}</td>
                    <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.MSD||0).toFixed(2)}</td>
                    <td style={{padding:'8px 10px',textAlign:'right',color:IOS.label}}>{parseFloat(l.CONS_ESTIMADO||0).toFixed(0)}</td>
                    <td style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:IOS.blue}}>{solicitado.toLocaleString()}</td>
                    <td style={{padding:'8px 10px',textAlign:'right'}}>
                      {propuesto>0
                        ?<Box sx={{display:'inline-flex',flexDirection:'column',alignItems:'flex-end',gap:0.2}}>
                          <Typography sx={{fontSize:'0.78rem',fontWeight:700,
                            color:propuesto<solicitado?IOS.orange:propuesto>solicitado?IOS.blue:IOS.green}}>
                            {propuesto.toLocaleString()}
                          </Typography>
                          {diffPct!==null&&<Typography sx={{fontSize: '0.72rem',fontWeight:700,
                            color:diffPct<0?IOS.red:diffPct>0?IOS.blue:IOS.green}}>
                            {diffPct>0?'+':''}{diffPct}%
                          </Typography>}
                        </Box>
                        :<Typography sx={{fontSize:'0.72rem',color:IOS.label3}}>—</Typography>
                      }
                    </td>
                    <td style={{padding:'8px 10px',textAlign:'right'}}>
                      {aprobado>0
                        ?<Typography sx={{fontSize:'0.78rem',fontWeight:700,color:'#059669'}}>{aprobado.toLocaleString()}</Typography>
                        :<Typography sx={{fontSize:'0.72rem',color:IOS.label3}}>—</Typography>
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr style={{backgroundColor:IOS.bg,borderTop:`2px solid ${IOS.separator}`}}>
                <td colSpan={7} style={{padding:'9px 10px',fontSize: '0.72rem',fontWeight:700,color:IOS.label2}}>
                  TOTALES — {lineas.length} productos
                </td>
                <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:IOS.blue,fontSize:'0.82rem'}}>
                  {lineas.reduce((s,l)=>s+parseFloat(l.CANT_SOLICITADA||0),0).toLocaleString()}
                </td>
                <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:IOS.orange,fontSize:'0.82rem'}}>
                  {lineas.reduce((s,l)=>s+parseFloat(l.CANT_PROPUESTA||0),0).toLocaleString()||'—'}
                </td>
                <td style={{padding:'9px 10px',textAlign:'right',fontWeight:800,color:'#059669',fontSize:'0.82rem'}}>
                  {lineas.reduce((s,l)=>s+parseFloat(l.CANT_APROBADA||0),0).toLocaleString()||'—'}
                </td>
              </tr>
            </tfoot>
          </table>
        </Box>
      </Box>}

      {/* Modal acción */}
      {accion&&(
        <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',
          display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onClick={()=>!procesando&&setAccion(null)}>
          <Box className="pharmacy-modal-panel pharmacy-card" onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:420,
              boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Typography sx={{fontSize:'1rem',fontWeight:700,color:IOS.label,mb:0.5}}>
              {estados[accion]?.label||accion}
            </Typography>
            <Typography sx={{fontSize:'0.78rem',color:IOS.label2,mb:2}}>
              Requerimiento {cabecera.REQ_NUMERO}
            </Typography>

            {accion==='RECHAZADO'&&(
              <Box sx={{mb:2}}>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,mb:0.5,textTransform:'uppercase',letterSpacing:'0.06em'}}>Motivo del rechazo</Typography>
                <textarea value={mensaje} onChange={e=>setMensaje(e.target.value)} rows={3}
                  style={{width:'100%',padding:'10px',border:`1px solid ${IOS.separator}`,borderRadius:8,
                    fontSize:'0.82rem',color:IOS.label,backgroundColor:IOS.bg,outline:'none',
                    fontFamily:'inherit',resize:'vertical',boxSizing:'border-box'}}/>
              </Box>
            )}

            {accion==='EN_PREPARACION'&&(
              <Box className="pharmacy-layout" sx={{mb:2,display:'flex',flexDirection:'column',gap:1.5}}>
                <Box>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,mb:0.5,textTransform:'uppercase',letterSpacing:'0.06em'}}>N° Guía SISMED</Typography>
                  <input value={nroGuia} onChange={e=>setNroGuia(e.target.value)}
                    style={{width:'100%',height:36,padding:'0 12px',border:`1px solid ${IOS.separator}`,
                      borderRadius:8,fontSize:'0.82rem',color:IOS.label,backgroundColor:IOS.bg,
                      outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}/>
                </Box>
                <Box>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,mb:0.5,textTransform:'uppercase',letterSpacing:'0.06em'}}>PDF Guía (opcional)</Typography>
                  <Box className="pharmacy-layout" sx={{position:'relative',height:36,border:`1px solid ${IOS.separator}`,
                    borderRadius:8,bgcolor:IOS.bg,display:'flex',alignItems:'center',px:1.5,gap:1,cursor:'pointer'}}
                    onClick={()=>document.getElementById('pdf-input').click()}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="1.8" strokeLinecap="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    <Typography sx={{fontSize:'0.78rem',color:pdfFile?IOS.label:IOS.label2}}>
                      {pdfFile?pdfFile.name:'Seleccionar PDF...'}
                    </Typography>
                    <input id="pdf-input" type="file" accept=".pdf" style={{display:'none'}}
                      onChange={e=>setPdfFile(e.target.files[0]||null)}/>
                  </Box>
                </Box>
              </Box>
            )}

            {accion==='LISTO'&&(
              <Box className="pharmacy-layout" sx={{mb:2,display:'flex',flexDirection:'column',gap:1.5}}>
                <Box sx={{p:1.5,bgcolor:`${IOS.blue}08`,borderRadius:'10px',
                  border:`1px solid ${IOS.blue}20`}}>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                    textTransform:'uppercase',letterSpacing:'0.06em',mb:0.3}}>
                    Total productos aprobados
                  </Typography>
                  <Typography sx={{fontSize:'1.4rem',fontWeight:800,color:IOS.blue,
                    letterSpacing:'-0.03em'}}>
                    {lineas.reduce((s,l)=>s+parseFloat(l.CANT_APROBADA||l.CANT_PROPUESTA||l.CANT_SOLICITADA||0),0).toLocaleString()}
                    <Typography component="span" sx={{fontSize:'0.72rem',fontWeight:500,
                      color:IOS.label2,ml:0.5}}>unidades</Typography>
                  </Typography>
                  <Typography sx={{fontSize: '0.72rem',color:IOS.label2,mt:0.2}}>
                    {lineas.filter(l=>parseFloat(l.CANT_APROBADA||l.CANT_PROPUESTA||0)>0).length} productos con cantidad aprobada
                  </Typography>
                </Box>
                <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:1.5}}>
                {[
                  {label:'N° Items',   value:nroItems,   set:setNroItems,   type:'number'},
                  {label:'N° Bultos',  value:nroBultos,  set:setNroBultos,  type:'number'},
                  {label:'Peso (kg)',  value:pesoKg,     set:setPesoKg,     type:'number'},
                ].map(({label,value,set,type})=>(
                  <Box key={label}>
                    <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,mb:0.5,textTransform:'uppercase',letterSpacing:'0.06em'}}>{label}</Typography>
                    <input type={type} value={value} onChange={e=>set(e.target.value)}
                      style={{width:'100%',height:36,padding:'0 10px',border:`1px solid ${IOS.separator}`,
                        borderRadius:8,fontSize:'0.82rem',color:IOS.label,backgroundColor:IOS.bg,
                        outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}/>
                  </Box>
                ))}
                </Box>
              </Box>
            )}

            <Box className="pharmacy-layout" sx={{display:'flex',gap:1,mt:1}}>
              <Box className="pharmacy-action" component="button" onClick={()=>setAccion(null)} disabled={procesando}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Cancelar
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={ejecutarAccion} disabled={procesando}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',
                  bgcolor:estados[accion]?.dot||IOS.blue,cursor:'pointer',
                  fontSize:'0.82rem',fontWeight:700,color:'white',
                  display:'flex',alignItems:'center',justifyContent:'center',gap:0.8}}>
                {procesando?<CircularProgress size={14} sx={{color:'white'}}/>:null}
                {procesando?'Procesando...':'Confirmar'}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {/* Modal recojo */}
      {modalRecojo&&(
        <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',
          display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onClick={()=>!guardandoRecojo&&setModalRecojo(false)}>
          <Box className="pharmacy-modal-panel pharmacy-card" onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:440,
              boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Typography sx={{fontSize:'1rem',fontWeight:700,color:IOS.label,mb:0.5}}>
              Programar recojo
            </Typography>
            <Typography sx={{fontSize:'0.78rem',color:IOS.label2,mb:2}}>
              Requerimiento {cabecera.REQ_NUMERO} — mínimo 1 hora de separación con otros recojos
            </Typography>
            <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:1.5,mb:2}}>
              <Box>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,mb:0.5,
                  textTransform:'uppercase',letterSpacing:'0.06em'}}>Fecha</Typography>
                <DatePickerIOS value={fechaRecojo} minDate={toYMD(new Date())}
                  onChange={val=>{
                    const [fy,fm,fd] = val.split('-').map(Number);
                    const dia = new Date(fy,fm-1,fd).getDay();
                    if(dia===0||dia===6){ alert('Solo lunes a viernes.'); return; }
                    setFechaRecojo(val);
                    cargarRecojosDia(val);
                  }} />
              </Box>
              <Box>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,mb:0.5,
                  textTransform:'uppercase',letterSpacing:'0.06em'}}>Hora</Typography>
                <input type="time" value={horaRecojo}
                  min="07:00" max="19:00"
                  onChange={e=>setHoraRecojo(e.target.value)}
                  style={{width:'100%',height:36,padding:'0 10px',border:`1px solid ${IOS.separator}`,
                    borderRadius:8,fontSize:'0.82rem',color:IOS.label,backgroundColor:IOS.bg,
                    outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}/>
              </Box>
            </Box>
            {/* Recojos del día */}
            {recojosDia.length>0&&(
              <Box sx={{mb:2,p:1.5,bgcolor:IOS.bg,borderRadius:'10px',border:`1px solid ${IOS.separator}`}}>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                  textTransform:'uppercase',letterSpacing:'0.06em',mb:1}}>
                  Recojos ese día
                </Typography>
                {recojosDia.map((r,i)=>(
                  <Box className="pharmacy-layout" key={i} sx={{display:'flex',alignItems:'center',justifyContent:'space-between',
                    py:0.6,borderBottom:i<recojosDia.length-1?`1px solid ${IOS.separator}`:'none'}}>
                    <Typography sx={{fontSize:'0.72rem',color:IOS.label,fontWeight:600}}>
                      {String(r.HORA_RECOJO||'').substring(0,5)}
                    </Typography>
                    <Typography sx={{fontSize:'0.72rem',color:IOS.label2,flex:1,mx:1,
                      overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                      {r.NOMBRE_IPRESS}
                    </Typography>
                    <Box sx={{px:0.8,py:0.2,borderRadius:'20px',bgcolor:'#FFF8E6',border:'1px solid #FFE9A0'}}>
                      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:'#8B6914'}}>{r.REQ_NUMERO}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
            {fechaRecojo&&recojosDia.length===0&&(
              <Box sx={{mb:2,p:1.5,bgcolor:'#EDFAF2',borderRadius:'10px',border:'1px solid #B7EFD0'}}>
                <Typography sx={{fontSize:'0.72rem',color:'#1A6B3C',fontWeight:600}}>
                  ✓ Sin recojos programados ese día
                </Typography>
              </Box>
            )}
            <Box className="pharmacy-layout" sx={{display:'flex',gap:1}}>
              <Box className="pharmacy-action" component="button" onClick={()=>setModalRecojo(false)} disabled={guardandoRecojo}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Cancelar
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={registrarRecojo}
                disabled={guardandoRecojo||!fechaRecojo||!horaRecojo}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',
                  bgcolor:'#059669',cursor:'pointer',fontSize:'0.82rem',fontWeight:700,color:'white',
                  opacity:!fechaRecojo||!horaRecojo?0.5:1,
                  display:'flex',alignItems:'center',justifyContent:'center',gap:0.8}}>
                {guardandoRecojo?<CircularProgress size={14} sx={{color:'white'}}/>:null}
                {guardandoRecojo?'Registrando...':'Confirmar recojo'}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

const DashboardRequerimiento = ({ ueId, api, estados }) => {
  const [data,      setData]      = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [tipoGrafTend, setTipoGrafTend] = useState('bar');
  const [mesActual, setMesActual] = useState(new Date());

  useEffect(()=>{ cargar(); },[]);

  const cargar = async () => {
    setLoading(true);
    try {
      const r = await api.get('/farmacia/requerimiento/historial', { params: { ueId } });
      if(r.data.success) procesarData(r.data.data);
    } catch(e){ console.error(e); } finally { setLoading(false); }
  };

  const procesarData = (historial) => {
    const total      = historial.length;
    const pendientes = historial.filter(r=>!['ENTREGADO','RECHAZADO'].includes(r.REQ_ESTADO)).length;
    const entregados = historial.filter(r=>r.REQ_ESTADO==='ENTREGADO').length;
    const rechazados = historial.filter(r=>r.REQ_ESTADO==='RECHAZADO').length;

    const porEstado = Object.entries(
      historial.reduce((acc,r)=>{ acc[r.REQ_ESTADO]=(acc[r.REQ_ESTADO]||0)+1; return acc; },{})
    ).map(([estado,cnt])=>({estado,cnt}));

    const porIpress = Object.entries(
      historial.reduce((acc,r)=>{ const k=r.NOMBRE_IPRESS||'?'; acc[k]=(acc[k]||0)+1; return acc; },{})
    ).sort((a,b)=>b[1]-a[1]).slice(0,8).map(([nombre,cnt])=>({nombre,cnt}));

    const totalSolicitado = historial.reduce((s,r)=>s+parseFloat(r.TOTAL_SOLICITADO||0),0);

    const recojos = historial
      .filter(r=>r.REQ_FECHA_RECOJO_PROG)
      .map(r=>{
        const raw = String(r.REQ_FECHA_RECOJO_PROG).substring(0,10);
        const [ry,rm,rd] = raw.split('-').map(Number);
        return {
          fecha:  new Date(ry, rm-1, rd),
          hora:   String(r.REQ_HORA_RECOJO_PROG||'').substring(0,5),
          ipress: r.NOMBRE_IPRESS||'',
          numero: r.REQ_NUMERO||'',
          estado: r.REQ_ESTADO||'',
        };
      })
      .sort((a,b)=>a.fecha-b.fecha);

    const ahora = new Date();
    const tendencia = Array.from({length:6},(_,i)=>{
      const d = new Date(ahora.getFullYear(), ahora.getMonth()-5+i, 1);
      const mes = `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,'0')}`;
      const label = d.toLocaleDateString('es-PE',{month:'short',year:'2-digit'});
      const cnt = historial.filter(r=>(r.REQ_PERIODO||'').startsWith(mes.substring(0,6))||
        (r.REQ_FECHA_ENVIO&&new Date(r.REQ_FECHA_ENVIO).getMonth()===d.getMonth()&&
         new Date(r.REQ_FECHA_ENVIO).getFullYear()===d.getFullYear())).length;
      return {label,cnt};
    });

    setData({total,pendientes,entregados,rechazados,porEstado,porIpress,totalSolicitado,recojos,tendencia});
  };

  if(loading) return <Box sx={{py:12,textAlign:'center'}}><CircularProgress sx={{color:IOS.blue}}/></Box>;
  if(!data)   return null;

  const maxIpress = Math.max(...data.porIpress.map(x=>x.cnt),1);


  const diasMes = () => {
    const y = mesActual.getFullYear();
    const m = mesActual.getMonth();
    const primero = new Date(y,m,1).getDay();
    const total   = new Date(y,m+1,0).getDate();
    return {primero, total, y, m};
  };
  const {primero,total:totalDias,y,m} = diasMes();

  const recojosPorDia = (dia) => data.recojos.filter(r=>
    r.fecha.getFullYear()===y && r.fecha.getMonth()===m && r.fecha.getDate()===dia
  );

  return (
    <Box>
      {/* Header */}
      <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',justifyContent:'flex-end',mb:2.5}}>

        <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cargar}
          sx={{width:34,height:34,borderRadius:'10px',border:`1px solid ${IOS.separator}`,
            bgcolor:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',
            transition:'all 0.15s','&:hover':{bgcolor:IOS.bg}}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
            <polyline points="23 4 23 10 17 10"/>
            <path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
        </Box>
      </Box>

      {/* KPIs */}
      <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr 1fr',sm:'repeat(4,1fr)'},gap:1.5,mb:2.5}}>
        {[
          { label:'Total solicitudes', valor:data.total, color:IOS.blue, sub:'historial completo',
            icon:<path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>, extra:<rect x="9" y="3" width="6" height="4" rx="1"/> },
          { label:'En proceso', valor:data.pendientes, color:'#8B5CF6', sub:'sin entregar ni rechazar',
            icon:<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></> },
          { label:'Entregados', valor:data.entregados, color:'#059669', sub:'completados',
            icon:<><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></> },
          { label:'Rechazados', valor:data.rechazados, color:IOS.red, sub:'requieren atención',
            icon:<><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></> },
        ].map(({label,valor,color,sub,icon,extra})=>(
          <PharmacyMetric key={label} label={label} value={valor} sub={sub} color={color} icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">{icon}{extra}</svg>} />
        ))}
      </Box>

      {/* PRIMERA FILA: Distribución por estado + Tendencia de solicitudes */}
      <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr', lg:'1fr 1fr'},gap:2,mb:2}}>

        {/* Distribución por estado */}
        <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2.5,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
          <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label,mb:0.3}}>
            Distribución por estado
          </Typography>
          <Typography sx={{fontSize: '0.72rem',color:IOS.label2,mb:2}}>
            {data.total} solicitudes totales
          </Typography>
          <RequerimientoDistribucion data={data.porEstado} total={data.total} estados={estados}/>
        </Box>

        {/* Tendencia de solicitudes (antes estaba en la segunda fila) */}
        <Box className="pharmacy-layout pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2.5,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,
          display:'flex',flexDirection:'column'}}>
          <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',mb:2}}>
            <Box>
              <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label,mb:0.3}}>
                Tendencia de solicitudes
              </Typography>
              <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>
                Últimos 6 meses
              </Typography>
            </Box>
            <Box className="pharmacy-layout" sx={{display:'flex',gap:0.4,bgcolor:IOS.bg,borderRadius:'10px',p:0.4}}>
              {[
                {key:'bar', icon:<><rect x="3" y="10" width="4" height="8" rx="1" fill="currentColor" opacity=".9"/><rect x="10" y="6" width="4" height="12" rx="1" fill="currentColor" opacity=".9"/><rect x="17" y="3" width="4" height="15" rx="1" fill="currentColor" opacity=".9"/></>},
                {key:'line',icon:<path d="M3 17l4-8 4 4 4-6 4 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>},
                {key:'area',icon:<><path d="M3 17l4-8 4 4 4-6 4 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/><path d="M3 17l4-8 4 4 4-6 4 3V20H3z" fill="currentColor" opacity=".2"/></>},
              ].map(({key,icon})=>(
                <Box className="pharmacy-layout" key={key} onClick={()=>setTipoGrafTend(key)}
                  sx={{width:30,height:30,borderRadius:'8px',cursor:'pointer',
                    display:'flex',alignItems:'center',justifyContent:'center',
                    transition:'all 0.15s',
                    bgcolor:tipoGrafTend===key?IOS.surface:'transparent',
                    boxShadow:tipoGrafTend===key?'0 1px 3px rgba(0,0,0,0.12)':'none',
                    color:tipoGrafTend===key?IOS.blue:IOS.label2}}>
                  <svg width="16" height="16" viewBox="0 0 24 24">{icon}</svg>
                </Box>
              ))}
            </Box>
          </Box>
          <RequerimientoTendencia data={data.tendencia} tipo={tipoGrafTend}/>
        </Box>
      </Box>

      {/* SEGUNDA FILA: IPRESS con más solicitudes + Calendario de recojos */}
      <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr', lg:'1fr 1fr'},gap:2,mb:2}}>

        {/* Top IPRESS (antes estaba en la primera fila) */}
        <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2.5,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
          <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label,mb:0.3}}>
            IPRESS con más solicitudes
          </Typography>
          <Typography sx={{fontSize: '0.72rem',color:IOS.label2,mb:2}}>
            Top 8 establecimientos
          </Typography>
          <Box className="pharmacy-layout" sx={{display:'flex',flexDirection:'column',gap:1}}>
            {data.porIpress.map(({nombre,cnt},i)=>{
              const pct = Math.round((cnt/maxIpress)*100);
              const color = i===0?IOS.blue:i===1?'#8B5CF6':i===2?IOS.green:IOS.label2;
              return(
                <Box key={nombre}>
                  <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',mb:0.4}}>
                    <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:0.8,minWidth:0,flex:1}}>
                      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color,minWidth:16}}>{i+1}</Typography>
                      <Typography sx={{fontSize:'0.72rem',color:IOS.label,overflow:'hidden',
                        textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{nombre}</Typography>
                    </Box>
                    <Typography sx={{fontSize:'0.72rem',fontWeight:700,color,ml:1,flexShrink:0}}>{cnt}</Typography>
                  </Box>
                  <Box sx={{height:4,bgcolor:`${color}18`,borderRadius:'20px',overflow:'hidden'}}>
                    <Box sx={{width:`${pct}%`,height:'100%',bgcolor:color,
                      borderRadius:'20px',transition:'width 1s ease'}}/>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* Calendario de recojos */}
        <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',overflow:'hidden',
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>

          {/* Header del calendario */}
          <Box sx={{px:2.5,pt:2.5,pb:1.5,borderBottom:`1px solid ${IOS.separator}`}}>
            <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <Box>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em'}}>
                  {mesActual.getFullYear()}
                </Typography>
                <Typography sx={{fontSize:'1.2rem',fontWeight:800,color:IOS.label,letterSpacing:'-0.02em'}}>
                  {mesActual.toLocaleDateString('es-PE',{weekday:'long',day:'numeric',month:'long'})
                    .replace(/^\w/,c=>c.toUpperCase())}
                </Typography>
              </Box>
              <Box className="pharmacy-layout" sx={{display:'flex',gap:0.5}}>
                {[['‹',()=>setMesActual(d=>new Date(d.getFullYear(),d.getMonth()-1,1))],
                  ['›',()=>setMesActual(d=>new Date(d.getFullYear(),d.getMonth()+1,1))]
                ].map(([lbl,fn])=>(
                  <Box className="pharmacy-layout pharmacy-action" key={lbl} component="button" onClick={fn}
                    sx={{width:30,height:30,borderRadius:'8px',border:`1px solid ${IOS.separator}`,
                      bgcolor:IOS.bg,cursor:'pointer',display:'flex',alignItems:'center',
                      justifyContent:'center',fontSize:'1rem',color:IOS.label,
                      transition:'all 0.15s','&:hover':{bgcolor:IOS.separator}}}>{lbl}</Box>
                ))}
              </Box>
            </Box>
          </Box>

          {/* Cuerpo del calendario */}
          {(()=>{
            const iPressList = [...new Set(data.recojos.map(r=>r.ipress))];
            const paleta = ['#0078D4','#7C3AED','#059669','#D97706','#DC2626','#DB2777','#0891B2','#65A30D'];
            const colorIpress = {};
            iPressList.forEach((ip,i)=>{ colorIpress[ip]=paleta[i%paleta.length]; });

            return(
              <Box>
                {/* Cabecera días */}
                <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',
                  borderBottom:`1px solid ${IOS.separator}`}}>
                  {['DOM','LUN','MAR','MIÉ','JUE','VIE','SÁB'].map((d,i)=>(
                    <Typography key={i} sx={{
                      textAlign:'center',fontSize: '0.72rem',fontWeight:700,py:1,
                      color:i===0||i===6?`${IOS.red}80`:IOS.label2,
                      letterSpacing:'0.05em'
                    }}>{d}</Typography>
                  ))}
                </Box>

                {/* Grid de días */}
                <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
                  {Array.from({length:primero},(_,i)=>(
                    <Box key={`e${i}`} sx={{
                      minHeight:90,
                      borderRight:`1px solid ${IOS.separator}`,
                      borderBottom:`1px solid ${IOS.separator}`,
                      bgcolor:`${IOS.bg}80`,
                    }}/>
                  ))}
                  {Array.from({length:totalDias},(_,i)=>{
                    const dia = i+1;
                    const recojosDiaCal = recojosPorDia(dia);
                    const hoy = new Date();
                    const esHoy = hoy.getDate()===dia&&hoy.getMonth()===m&&hoy.getFullYear()===y;
                    const col = (primero+i)%7;
                    const esFinde = col===0||col===6;
                    const esBordeR = col<6;
                    return(
                      <Box className="pharmacy-layout" key={dia} sx={{
                        minHeight:90,p:0.5,
                        bgcolor:esHoy?`${IOS.blue}06`:esFinde?`${IOS.bg}60`:'transparent',
                        borderRight:esBordeR?`1px solid ${IOS.separator}`:'none',
                        borderBottom:`1px solid ${IOS.separator}`,
                        display:'flex',flexDirection:'column',gap:'2px',
                      }}>
                        {/* Número día */}
                        <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'flex-end',mb:0.3,px:0.3}}>
                          <Box className="pharmacy-layout" sx={{
                            width:24,height:24,borderRadius:'50%',
                            bgcolor:esHoy?IOS.blue:'transparent',
                            display:'flex',alignItems:'center',justifyContent:'center',
                          }}>
                            <Typography sx={{
                              fontSize:'0.72rem',lineHeight:1,
                              fontWeight:esHoy?700:recojosDiaCal.length>0?600:400,
                              color:esHoy?'white':esFinde?IOS.label2:IOS.label,
                            }}>{dia}</Typography>
                          </Box>
                        </Box>
                        {/* Eventos estilo Google Calendar */}
                        {recojosDiaCal.slice(0,3).map((r,ri)=>{
                          const color = colorIpress[r.ipress]||IOS.blue;
                          const nombre = r.ipress.split(' ').slice(0,3).join(' ');
                          return(
                            <Box key={ri} sx={{
                              borderRadius:'4px',
                              px:0.6,py:'2px',
                              bgcolor:color,
                              cursor:'pointer',
                              transition:'filter 0.15s',
                              '&:hover':{filter:'brightness(0.88)'},
                            }}>
                              <Typography sx={{
                                fontSize: '0.72rem',fontWeight:600,color:'white',
                                overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',
                                lineHeight:1.4,
                              }}>
                                {r.hora} {nombre}
                              </Typography>
                            </Box>
                          );
                        })}
                        {recojosDiaCal.length>3&&(
                          <Typography sx={{fontSize: '0.72rem',color:IOS.label2,pl:0.5,lineHeight:1.4}}>
                            +{recojosDiaCal.length-3} más
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                  {/* Relleno final */}
                  {Array.from({length:(7-((primero+totalDias)%7))%7},(_,i)=>(
                    <Box key={`f${i}`} sx={{
                      minHeight:90,
                      borderRight:i<(7-((primero+totalDias)%7))%7-1?`1px solid ${IOS.separator}`:'none',
                      borderBottom:`1px solid ${IOS.separator}`,
                      bgcolor:`${IOS.bg}80`,
                    }}/>
                  ))}
                </Box>
              </Box>
            );
          })()}
        </Box>
      </Box>

      {/* Próximos recojos (sin cambios) */}
      {data.recojos.filter(r=>r.fecha>=new Date()).length>0&&(
        <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2.5,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,mb:2}}>
          <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label,mb:0.3}}>
            Próximos recojos
          </Typography>
          <Typography sx={{fontSize: '0.72rem',color:IOS.label2,mb:2}}>
            Recojos programados pendientes
          </Typography>
          <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr',sm:'repeat(2,1fr)',md:'repeat(3,1fr)'},gap:1.5}}>
            {data.recojos.filter(r=>r.fecha>=new Date()).slice(0,6).map((r,i)=>{
              const cfg = estados[r.estado] || {dot:IOS.label3,bg:IOS.bg,border:IOS.separator,text:IOS.label2,label:r.estado};
              const diasRestantes = Math.ceil((r.fecha-new Date())/(1000*60*60*24));
              return(
                <Box className="pharmacy-layout" key={i} sx={{p:1.8,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,display:'flex',gap:1.5,alignItems:'flex-start'}}>
                  <Box className="pharmacy-layout" sx={{width:44,height:44,borderRadius:'10px',bgcolor:'#ECFDF5',
                    border:'1px solid #A7F3D0',display:'flex',flexDirection:'column',
                    alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    <Typography sx={{fontSize:'1rem',fontWeight:800,color:'#059669',lineHeight:1}}>
                      {r.fecha.getDate()}
                    </Typography>
                    <Typography sx={{fontSize: '0.72rem',fontWeight:600,color:'#059669',lineHeight:1.2}}>
                      {r.fecha.toLocaleDateString('es-PE',{month:'short'})}
                    </Typography>
                  </Box>
                  <Box sx={{flex:1,minWidth:0}}>
                    <Typography sx={{fontSize:'0.75rem',fontWeight:700,color:IOS.label,
                      overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',mb:0.3}}>
                      {r.ipress}
                    </Typography>
                    <Typography sx={{fontSize: '0.72rem',color:IOS.label2,mb:0.5}}>
                      {r.hora} hrs · {r.numero}
                    </Typography>
                    <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:0.8}}>
                      <Box sx={{display:'inline-flex',alignItems:'center',gap:0.4,px:0.7,py:0.2,
                        borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`}}>
                        <Box sx={{width:4,height:4,borderRadius:'50%',bgcolor:cfg.dot}}/>
                        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text}}>{cfg.label}</Typography>
                      </Box>
                      <Typography sx={{fontSize: '0.72rem',color:diasRestantes<=1?IOS.red:diasRestantes<=3?IOS.orange:IOS.label2,fontWeight:diasRestantes<=3?700:400}}>
                        {diasRestantes===0?'Hoy':diasRestantes===1?'Mañana':`En ${diasRestantes} días`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

const Requerimiento = () => {
  const navigate = useNavigate();
  const user     = authService.getCurrentUser();
  const ueId     = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;
  const periodo  = getPeriodo();
  const idEstabUsuario = String(user?.idEstablecimiento||user?.IdEstablecimiento||0);
const [privReq, setPrivReq] = useState('Solo lectura');

useEffect(()=>{
  api.get('/dashboard/permisos').then(r=>{
    if(r.data.success){
      const op = r.data.opciones.find(o=>
        (o.permiso||'').toLowerCase().includes('requerimiento')
      );
      if(op) setPrivReq(op.privilegio||'Solo lectura');
    }
  }).catch(()=>{});
},[]);

const esTOTAL    = privReq === 'Total';
const esPARCIAL  = privReq === 'Lectura/Escritura';
const esSoloLect = privReq === 'Solo lectura';

  const [ipressList,    setIpressList]    = useState([]);
  const [loadIP,        setLoadIP]        = useState(true);
  const [idAlmacen,     setIdAlmacen]     = useState(0);
  const [filtroIpress,  setFiltroIpress]  = useState('');
  const [filtroTipo,    setFiltroTipo]    = useState('C');
  const [filtroMeses,   setFiltroMeses]   = useState('3');
  const [indsDisp,      setIndsDisp]      = useState([]);
  const [filtroInds,    setFiltroInds]    = useState([]);
  const [filtroEst,     setFiltroEst]     = useState('TODOS');
  const [filtroTipoProd,setFiltroTipoProd]= useState('TODOS');
  const [filtroNuevo,   setFiltroNuevo]   = useState('INCLUIR');
  const [filtroDisp,    setFiltroDisp]    = useState('TODOS');
  const [busqueda,      setBusqueda]      = useState('');
  const [datosOrig,     setDatosOrig]     = useState([]);
  const [datos,         setDatos]         = useState([]);
  const [cargando,      setCargando]      = useState(false);
  const [descargando,   setDescargando]   = useState(false);
  const [modalExp,      setModalExp]      = useState(false);
  const [hayEdiciones,  setHayEdiciones]  = useState(false);
  const [guardando,     setGuardando]     = useState(false);
  const [reqGuardado,   setReqGuardado]   = useState(null); // { reqId, numero, totalLineas }
  const [tabPrincipal,  setTabPrincipal]  = useState(0);
  const [historial,     setHistorial]     = useState([]);
  const [loadHist,      setLoadHist]      = useState(false);
  const [reqSelec,      setReqSelec]      = useState(null); // requerimiento seleccionado para ver detalle
  const [detalleReq,    setDetalleReq]    = useState(null);
  const [loadDetalle,   setLoadDetalle]   = useState(false);
  const [modalGuardado, setModalGuardado] = useState(false);
  const [pagina,        setPagina]        = useState(1);
  const [rpp,           setRpp]           = useState(50);

  const handleLogout = () => { authService.logout(); navigate('/login'); };

  useEffect(() => {
  if(!privReq) return;
  setLoadIP(true);
  api.get(`/farmacia/requerimiento/listar-ipress?idEjecutora=${ueId}`)
    .then(r => {
      const lista = (r.data?.data??[]).filter(x=>String(x.id)!=='0').map(x=>({ id:String(x.id), nombre:x.nombre||x.NOMBRE||'' }));
      if(lista.length>0){
        const miIpress = lista.find(ip=>ip.id===idEstabUsuario)||lista[0];
        if(privReq==='Total'){
          setIpressList(lista);
          setFiltroIpress(miIpress.id);
        } else {
          setIpressList([miIpress]);
          setFiltroIpress(miIpress.id);
        }
      }
    }).catch(console.error).finally(()=>setLoadIP(false));
}, [ueId, privReq]);

useEffect(()=>{
    if(!ueId) return;
    api.get(`/farmacia/requerimiento/almacen-ue?ueId=${ueId}`)
      .then(r=>{ if(r.data.success) setIdAlmacen(r.data.idAlmacen); })
      .catch(console.error);
  },[ueId]);

  useEffect(()=>{
    if(tabPrincipal!==1) return;
    if(!privReq) return;
    if(esTOTAL){
      cargarHistorial();
    } else {
      if(filtroIpress||idEstabUsuario) cargarHistorial();
    }
  },[tabPrincipal, idAlmacen, filtroIpress, privReq]);

  const cargar = async () => {
    if(!filtroIpress) return;
    setCargando(true);
    try {
      const r = await api.get('/farmacia/requerimiento/consolidado', { params:{ periodo, idEstablecimiento:filtroIpress, tipo:filtroTipo, meses:filtroMeses } });
      if(r.data.success) {
        const d = r.data.data.map((x,i)=>({ ...x, _id:i, _eliminado:false }));
        setDatosOrig(d); setDatos(d);
        const inds = [...new Set(d.map(x=>x.indicadorDigemid).filter(Boolean))].sort();
        setIndsDisp(inds); setFiltroInds(inds);
        setFiltroEst('TODOS'); setFiltroTipoProd('TODOS'); setFiltroNuevo('INCLUIR'); setFiltroDisp('TODOS');
        setBusqueda(''); setHayEdiciones(false); setPagina(1);
      }
    } catch(e){ console.error(e); } finally { setCargando(false); }
  };

  const restaurar    = () => { setDatos(datosOrig); setHayEdiciones(false); };
  const editarReq    = (id,v) => { setDatos(prev=>prev.map(d=>d._id===id?{ ...d, requerimiento:v }:d)); setHayEdiciones(true); };
  const eliminarFila = (id) => { setDatos(prev=>prev.map(d=>d._id===id?{ ...d, _eliminado:true }:d)); setHayEdiciones(true); };

  const datosFiltrados = datos.filter(d => {
    if(d._eliminado) return false;
    if(filtroNuevo==='EXCLUIR'&&(d.productoNuevo==='SI'||d.productoNuevo==='S')) return false;
    if(busqueda.length>=2){ const b=busqueda.toUpperCase(); if(!(d.producto?.toUpperCase().includes(b)||d.codigoMed?.toUpperCase().includes(b))) return false; }
    if(filtroInds.length>0&&filtroInds.length<indsDisp.length&&!filtroInds.includes(d.indicadorDigemid)) return false;
    if(filtroEst==='E'&&d.estrategico!=='E') return false;
    if(filtroEst==='NO'&&d.estrategico==='E') return false;
    if(filtroTipoProd==='M'&&d.tipoProducto!=='M') return false;
    if(filtroTipoProd==='I'&&d.tipoProducto!=='I') return false;
    if(filtroDisp==='SI'&&d.disponibleAlmacen!=='SI') return false;
    if(filtroDisp==='NO'&&d.disponibleAlmacen==='SI') return false;
    return true;
  });

  const paginados     = datosFiltrados.slice((pagina-1)*rpp, pagina*rpp);
  const hayDatos      = datos.length>0;
  const totalReq      = datosFiltrados.reduce((s,d)=>s+parseFloat(d.requerimiento||0),0);
  const conReq        = datosFiltrados.filter(d=>parseFloat(d.requerimiento||0)>0).length;
  const disponibles   = datosFiltrados.filter(d=>d.disponibleAlmacen==='SI').length;
  const noDisponibles = datosFiltrados.filter(d=>d.disponibleAlmacen!=='SI').length;
  const cantNuevos    = datosFiltrados.filter(d=>d.productoNuevo==='SI'||d.productoNuevo==='S').length;

  const histAbortRef = useRef(null);
  const cargarHistorial = async () => {
    if(histAbortRef.current) histAbortRef.current.abort();
    histAbortRef.current = new AbortController();
    setLoadHist(true);
    try {
      let params = { ueId };
      if(esTOTAL){
        if(filtroIpress) params.idIpress = parseInt(filtroIpress);
      } else {
        const ipId = parseInt(filtroIpress||idEstabUsuario||0);
        if(!ipId) return;
        params.idIpress = ipId;
      }
      const r = await api.get('/farmacia/requerimiento/historial', { params, signal: histAbortRef.current.signal });
      if(r.data.success) setHistorial(r.data.data);
    } catch(e){ if(e.name!=='CanceledError'&&e.code!=='ERR_CANCELED') console.error(e); }
    finally { setLoadHist(false); }
  };

  const cargarDetalle = async (reqId) => {
    setLoadDetalle(true);
    try {
      const r = await api.get(`/farmacia/requerimiento/${reqId}/detalle`);
      if(r.data.success) setDetalleReq(r.data);
    } catch(e){ console.error(e); } finally { setLoadDetalle(false); }
  };

  const cambiarEstado = async (reqId, nuevoEstado, extra={}) => {
    try {
      const r = await api.put(`/farmacia/requerimiento/${reqId}/estado`, {
        nuevoEstado,
        usuario: user?.nombreCompleto || user?.usuario || '',
        ...extra
      });
      if(r.data.success){
        cargarHistorial();
        if(detalleReq) cargarDetalle(reqId);
      }
    } catch(e){ console.error(e); }
  };

  const guardar = async () => {
    if(!filtroIpress || datosFiltrados.filter(d=>parseFloat(d.requerimiento||0)>0).length===0) return;
    setGuardando(true);
    try {
      const almacenId = idAlmacen || 0;
      const r = await api.post('/farmacia/requerimiento/guardar', {
        idIpress:     parseInt(filtroIpress),
        idAlmacen:    almacenId,
        periodo:      periodo,
        tipo:         filtroTipo,
        meses:        parseInt(filtroMeses),
        enviadoPor:   user?.nombreCompleto || user?.usuario || '',
        datos:        datosFiltrados.filter(d=>parseFloat(d.requerimiento||0)>0).map(d=>({
          codigoMed:        d.codigoMed,
          producto:         d.producto,
          tipoProducto:     d.tipoProducto,
          estrategico:      d.estrategico,
          cpma:             d.cpma,
          stockIpress:      d.stockIpress,
          msd:              d.msd,
          indicadorDigemid: d.indicadorDigemid,
          stockAlmacenes:   d.stockAlmacenes,
          disponibleAlmacen:d.disponibleAlmacen,
          consumoEstimado:  d.consumoEstimado,
          requerimiento:    parseFloat(d.requerimiento||0)
        }))
      });
      if(r.data.success){
        setReqGuardado(r.data);
        setModalGuardado(true);
      }
    } catch(e){ console.error(e); alert('Error al guardar requerimiento'); }
    finally { setGuardando(false); }
  };

  const exportar = async (tipo) => {
    setDescargando(true);
    try {
      const mime = tipo==='excel'?'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':'application/pdf';
      const ext  = tipo==='excel'?'xlsx':'pdf';
      const payload = { periodo, idEstablecimiento:parseInt(filtroIpress), tipo:filtroTipo, meses:parseInt(filtroMeses),
        datos:datosFiltrados.map(d=>({ codigoMed:d.codigoMed, producto:d.producto, tipoProducto:d.tipoProducto, estrategico:d.estrategico, cpma:d.cpma, stockIpress:d.stockIpress, msd:d.msd, indicadorDigemid:d.indicadorDigemid, stockAlmacenes:d.stockAlmacenes, disponibleAlmacen:d.disponibleAlmacen, productoNuevo:d.productoNuevo, consumoEstimado:d.consumoEstimado, requerimiento:parseFloat(d.requerimiento||0) })) };
      const resp = await api.post(`/farmacia/requerimiento/exportar-${tipo}`, payload, { responseType:'blob' });
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(new Blob([resp.data],{type:mime}));
      a.download = `Requerimiento_${periodo}.${ext}`;
      a.click(); window.URL.revokeObjectURL(a.href); setModalExp(false);
    } catch(e){ console.error(e); } finally { setDescargando(false); }
  };

  const ModalGuardado = () => {
    if(!modalGuardado||!reqGuardado) return null;
    return (
      <Box className="pharmacy-page req-page req-overlay pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',
        display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
        onClick={()=>setModalGuardado(false)}>
        <Box className="pharmacy-modal-panel pharmacy-card" onClick={e=>e.stopPropagation()}
          sx={{bgcolor:IOS.surface,borderRadius:'20px',overflow:'hidden',
            width:360,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
          <Box sx={{px:3,pt:3,pb:2.5,textAlign:'center'}}>
            <Box className="pharmacy-layout" sx={{width:64,height:64,borderRadius:'50%',bgcolor:'#EDFAF2',
              display:'flex',alignItems:'center',justifyContent:'center',mx:'auto',mb:2}}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                stroke="#34C759" strokeWidth="2" strokeLinecap="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </Box>
            <Typography sx={{fontSize:'1.1rem',fontWeight:800,color:IOS.label,mb:0.5}}>
              Requerimiento enviado
            </Typography>
            <Typography sx={{fontSize:'0.82rem',color:IOS.label2,mb:2}}>
              Tu requerimiento fue registrado exitosamente
            </Typography>
            <Box sx={{bgcolor:IOS.bg,borderRadius:'12px',p:2,mb:2.5}}>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
                letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>N° Requerimiento</Typography>
              <Typography sx={{fontSize:'2rem',fontWeight:800,color:IOS.blue,
                letterSpacing:'-0.04em'}}>{reqGuardado.numero}</Typography>
              <Typography sx={{fontSize:'0.72rem',color:IOS.label2,mt:0.5}}>
                {reqGuardado.totalLineas} productos con requerimiento &gt; 0
              </Typography>
            </Box>
            <Box className="pharmacy-layout" sx={{display:'flex',gap:1}}>
              <Box className="pharmacy-action" component="button" onClick={()=>setModalGuardado(false)}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,
                  bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,
                  color:IOS.label,transition:'all 0.15s','&:hover':{bgcolor:IOS.separator}}}>
                Cerrar
              </Box>
              <Box className="pharmacy-action" component="button" onClick={()=>{setModalGuardado(false);setTabPrincipal(1);}}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',
                  bgcolor:IOS.blue,cursor:'pointer',fontSize:'0.82rem',fontWeight:700,
                  color:'white',transition:'all 0.15s','&:hover':{filter:'brightness(0.92)'}}}>
                Ver historial
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  // ── Config de estados ──────────────────────────────────────────────────────
  const ESTADOS = {
    ENVIADO:        { label:'Enviado',          dot:'#0078D4', bg:'#EBF5FF', border:'#BFDBFE', text:'#1D4ED8' },
    RECIBIDO:       { label:'Recibido',         dot:'#8B5CF6', bg:'#F5F3FF', border:'#DDD6FE', text:'#6D28D9' },
    RECHAZADO:      { label:'Rechazado',        dot:'#FF3B30', bg:'#FFF0EF', border:'#FFD4D1', text:'#C0392B' },
    EN_EVALUACION:  { label:'En evaluación',    dot:'#FF9500', bg:'#FFF8E6', border:'#FFE9A0', text:'#8B6914' },
    APROBADO:       { label:'Aprobado',         dot:'#34C759', bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C' },
    EN_PREPARACION: { label:'En preparación',   dot:'#5E5CE6', bg:'#F0EFFF', border:'#C7C7F0', text:'#3730A3' },
    LISTO:          { label:'Listo para recojo', dot:'#059669', bg:'#ECFDF5', border:'#A7F3D0', text:'#065F46' },
    ENTREGADO:      { label:'Entregado',        dot:'#8E8E93', bg:'#F2F2F7', border:'#D1D1D6', text:'#636366' },
  };

  const EstadoPill = ({ estado }) => {
    const cfg = ESTADOS[estado] || { label:estado, dot:IOS.label3, bg:IOS.bg, border:IOS.separator, text:IOS.label2 };
    return (
      <Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:1,py:0.3,
        borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`}}>
        <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:cfg.dot,flexShrink:0}}/>
        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text,whiteSpace:'nowrap'}}>{cfg.label}</Typography>
      </Box>
    );
  };

  return (
    <Box className="pharmacy-page req-page" sx={{ minHeight:'100vh', bgcolor:IOS.bg }}>
      <ModalGuardado/>
      <HeaderIOS titulo="Requerimiento" subtitulo="Farmacia"
        onHome={()=>navigate('/farmacia')} onLogout={handleLogout}
        nombreCompleto={user?.nombreCompleto||user?.usuario||''}
        avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />

      <Box className="pharmacy-content req-content" sx={{ maxWidth:1600, mx:'auto', px:{ xs:1.5, sm:2.6 }, pt:2.5, pb:6 }}>

        {/* Tabs principales */}
        <Box className="pharmacy-inline-tabs pharmacy-layout req-tabs" sx={{display:'flex',alignItems:'center',justifyContent:'space-between',mb:2.5,flexWrap:'wrap',gap:1.5}}>
          <PharmacyTabs value={tabPrincipal} onChange={setTabPrincipal} options={[{value:0,label:'Nuevo requerimiento'},{value:1,label:esTOTAL?'Gestión de pedidos':'Mis pedidos'},...(esTOTAL?[{value:2,label:'Dashboard'}]:[])]}/>
        </Box>

        <section className="req-heading"><div><span>Abastecimiento · Farmacia</span><h1>{['Planifica lo que necesitas','Cada pedido, en seguimiento','Tus requerimientos, en perspectiva'][tabPrincipal]}</h1><p>{['Revisa existencias y prepara el próximo pedido.','Consulta el avance de los pedidos hasta su entrega.','Explora las solicitudes, sus estados y los próximos recojos.'][tabPrincipal]}</p></div>{tabPrincipal===0&&<div className="req-period"><span>Período de trabajo</span><strong>{new Date().toLocaleDateString('es-PE',{month:'long',year:'numeric'})}</strong></div>}</section>

        {/* ── TAB 0: NUEVO REQUERIMIENTO ── */}
        {tabPrincipal===0&&(
          <Box>
            {/* Filtros principales */}
            <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2.5,
              boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2.5 }}>
              <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-end' }}>
                {esTOTAL
                  ? <Sel label="IPRESS" value={filtroIpress} onChange={e=>setFiltroIpress(e.target.value)} disabled={loadIP} w={280}>
                      {loadIP?<option>Cargando...</option>:ipressList.map(ip=><option key={ip.id} value={ip.id}>{ip.nombre}</option>)}
                    </Sel>
                  : <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>IPRESS</Typography>
                      <Box className="pharmacy-layout" sx={{ height:34, px:1.5, display:'flex', alignItems:'center', border:`1px solid ${IOS.separator}`, borderRadius:8, bgcolor:IOS.bg, minWidth:280 }}>
                        <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                          {ipressList[0]?.nombre||'Cargando...'}
                        </Typography>
                      </Box>
                    </Box>
                }
                <Sel label="Tipo" value={filtroTipo} onChange={e=>setFiltroTipo(e.target.value)} w={150}>
                  <option value="C">Completo</option>
                  <option value="ME">Med. Esenciales</option>
                </Sel>
                <Sel label="Meses Cobertura" value={filtroMeses} onChange={e=>setFiltroMeses(e.target.value)} w={130}>
                  <option value="1">1 mes</option>
                  <option value="2">2 meses</option>
                  <option value="3">3 meses</option>
                  <option value="6">6 meses</option>
                </Sel>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cargar} disabled={cargando||!filtroIpress}
                  sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', alignSelf:'flex-end',
                    bgcolor:IOS.blue, cursor:(cargando||!filtroIpress)?'default':'pointer',
                    display:'flex', alignItems:'center', gap:0.8, opacity:!filtroIpress?0.5:1,
                    transition:'all 0.2s', '&:hover':{ filter:'brightness(0.92)' } }}>
                  {cargando?<CircularProgress size={13} sx={{ color:'white' }} />
                    :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>}
                  <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>{cargando?'Consultando...':'Consultar'}</Typography>
                </Box>
                {hayEdiciones && (
                  <Tooltip title="Restaurar datos originales" placement="top">
                    <Box className="pharmacy-layout pharmacy-action" component="button" onClick={restaurar}
                      sx={{ height:34, px:2, borderRadius:'10px', border:`1px solid ${IOS.separator}`,
                        bgcolor:IOS.surface, cursor:'pointer', display:'flex', alignItems:'center', gap:0.8,
                        alignSelf:'flex-end', transition:'all 0.15s', '&:hover':{ bgcolor:'#FFF8E6', borderColor:'#FFE9A0' } }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2.2" strokeLinecap="round">
                        <path d="M23 4v6h-6"/><path d="M1 20v-6h6"/>
                        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                      </svg>
                      <Typography sx={{ fontSize:'0.8rem', fontWeight:600, color:IOS.orange }}>Restaurar</Typography>
                    </Box>
                  </Tooltip>
                )}
                {hayDatos && (
                  <Box className="pharmacy-layout" sx={{ ml:'auto', alignSelf:'flex-end', display:'flex', alignItems:'center', gap:0.8,
                    px:1.5, py:0.6, bgcolor:IOS.bg, borderRadius:'20px', border:`1px solid ${IOS.separator}` }}>
                    <Box sx={{ width:7, height:7, borderRadius:'50%', bgcolor:IOS.green }} />
                    <Typography sx={{ fontSize:'0.72rem', fontWeight:600, color:IOS.label2 }}>
                      {datos.filter(d=>!d._eliminado).length.toLocaleString()} registros
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {!hayDatos && !cargando && (
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                <Box className="pharmacy-layout" sx={{ width:60, height:60, borderRadius:'50%', bgcolor:`${IOS.blue}12`,
                  display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round">
                    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
                    <rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/>
                  </svg>
                </Box>
                <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, mb:0.5 }}>Listo para consultar</Typography>
                <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Selecciona la IPRESS y presiona Consultar</Typography>
              </Box>
            )}

            {cargando && <Box sx={{ py:12, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}

            {hayDatos && !cargando && (
              <Box>
                <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{xs:'repeat(2,minmax(0,1fr))',lg:'repeat(4,minmax(0,1fr))'}, gap:1.5, mb:2 }}>
                  <KpiCard label="Total Requerimiento" valor={fmt0(totalReq)} sub="unidades" color={IOS.blue}
                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>} />
                  <KpiCard label="Con Requerimiento" valor={conReq.toLocaleString()} sub={`de ${datosFiltrados.length} productos`} color={IOS.purple}
                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="1.8" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>} />
                  <KpiCard label="Disponible Almacen" valor={disponibles.toLocaleString()} sub="con stock" color={IOS.green}
                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>} />
                  <KpiCard label="No Disponible" valor={noDisponibles.toLocaleString()} sub="sin stock en almacen" color={IOS.red}
                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>} />
                </Box>

                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px',
                  boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                  <Box sx={{ p:2.5, borderBottom:`1px solid ${IOS.separator}` }}>
                    <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', mb:2 }}>
                      <Box>
                        <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>Stock Detallado con Requerimiento</Typography>
                        <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5, mt:0.3 }}>
                          <Typography sx={{ fontSize:'0.7rem', color:IOS.label2 }}>
                            {datosFiltrados.length.toLocaleString()} de {datos.filter(d=>!d._eliminado).length.toLocaleString()} registros
                          </Typography>
                          {hayEdiciones && (
                            <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2,
                              borderRadius:'20px', bgcolor:'#FFF8E6', border:'1px solid #FFE9A0' }}>
                              <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:IOS.orange }} />
                              <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#8B6914' }}>Cambios sin enviar</Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                      <Box className="pharmacy-layout" sx={{display:'flex',gap:1,alignItems:'center'}}>
                        <Box className="pharmacy-layout pharmacy-action" component="button" onClick={guardar}
                          disabled={guardando||datosFiltrados.filter(d=>parseFloat(d.requerimiento||0)>0).length===0}
                          sx={{height:32,px:2,borderRadius:'10px',border:'none',
                            bgcolor:IOS.blue,cursor:'pointer',display:'flex',alignItems:'center',gap:0.8,
                            opacity:datosFiltrados.filter(d=>parseFloat(d.requerimiento||0)>0).length===0?0.4:1,
                            transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                          {guardando
                            ?<CircularProgress size={13} sx={{color:'white'}}/>
                            :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round">
                              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                              <polyline points="17 21 17 13 7 13 7 21"/>
                              <polyline points="7 3 7 8 15 8"/>
                            </svg>
                          }
                          <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:'white'}}>
                            {guardando?'Guardando...':'Enviar requerimiento'}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:1.5, flexWrap:'wrap', alignItems:'flex-end' }}>
                      <MultiSelectInd opciones={indsDisp} seleccionados={filtroInds} onChange={v=>{setFiltroInds(v);setPagina(1);}} />
                      <Sel label="Estrategico" value={filtroEst} onChange={e=>{setFiltroEst(e.target.value);setPagina(1);}} w={150}>
                        <option value="TODOS">Todos</option>
                        <option value="E">Estrategico</option>
                        <option value="NO">No estrategico</option>
                      </Sel>
                      <Sel label="Tipo Producto" value={filtroTipoProd} onChange={e=>{setFiltroTipoProd(e.target.value);setPagina(1);}} w={140}>
                        <option value="TODOS">Todos</option>
                        <option value="M">Medicamento</option>
                        <option value="I">Insumo</option>
                      </Sel>
                      <Sel label="Nuevo en Almacen" value={filtroNuevo} onChange={e=>{setFiltroNuevo(e.target.value);setPagina(1);}} w={150}>
                        <option value="INCLUIR">Incluir nuevos</option>
                        <option value="EXCLUIR">Solo mis consumos</option>
                      </Sel>
                      <Sel label="Disp. Almacen" value={filtroDisp} onChange={e=>{setFiltroDisp(e.target.value);setPagina(1);}} w={130}>
                        <option value="TODOS">Todos</option>
                        <option value="SI">Disponible</option>
                        <option value="NO">No disponible</option>
                      </Sel>
                      <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3, flex:1, minWidth:180 }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Buscar</Typography>
                        <Box sx={{ position:'relative' }}>
                          <Box sx={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:IOS.label2 }}>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                          </Box>
                          <input type="text" placeholder="Codigo o producto..." value={busqueda}
                            onChange={e=>{setBusqueda(e.target.value);setPagina(1);}}
                            style={{ width:'100%', height:34, paddingLeft:28, paddingRight:10,
                              border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.8rem',
                              color:IOS.label, backgroundColor:IOS.surface, outline:'none',
                              boxSizing:'border-box', fontFamily:'inherit' }}
                            onFocus={e=>e.target.style.borderColor=IOS.blue}
                            onBlur={e=>e.target.style.borderColor=IOS.separator} />
                        </Box>
                      </Box>
                      {cantNuevos>0 && (
                        <Box sx={{ alignSelf:'flex-end', display:'inline-flex', alignItems:'center', gap:0.5,
                          px:1, py:0.5, borderRadius:'20px',
                          bgcolor:filtroNuevo==='EXCLUIR'?'#FFF8E6':'#EDFAF2',
                          border:`1px solid ${filtroNuevo==='EXCLUIR'?'#FFE9A0':'#B7EFD0'}` }}>
                          <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:filtroNuevo==='EXCLUIR'?IOS.orange:IOS.green }} />
                          <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:filtroNuevo==='EXCLUIR'?'#8B6914':'#1A6B3C' }}>
                            {cantNuevos} {filtroNuevo==='EXCLUIR'?'excluidos':'nuevos'}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ overflowX:'auto', overflowY:'auto', maxHeight:'calc(100vh - 520px)',
                    '&::-webkit-scrollbar':{ width:4, height:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', minWidth:1100, fontSize:'0.75rem' }}>
                      <thead style={{ position:'sticky', top:0, zIndex:2 }}>
                        <tr>
                          {['#','Codigo','Producto','Tipo','Est.','CPMA','Stk IPRESS','MSD','Indicador','Stk Almacen','Disp.','Nuevo','Cons. Est.','Requerimiento',''].map((h,i)=>(
                            <th key={i} style={{ padding:'9px 10px',
                              textAlign:i>=5&&i<=13?'right':i===14?'center':'left',
                              fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em',
                              textTransform:'uppercase', backgroundColor:IOS.surface,
                              borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginados.map((d,idx)=>{
                          const reqVal  = parseFloat(d.requerimiento||0);
                          const esNuevo = d.productoNuevo==='SI'||d.productoNuevo==='S';
                          return (
                            <tr key={d._id}
                              style={{ borderBottom:`1px solid ${IOS.separator}`,
                                backgroundColor:esNuevo?'#FFFDF0':IOS.surface, transition:'background 0.1s' }}
                              onMouseEnter={e=>e.currentTarget.style.backgroundColor=esNuevo?'#FFF8E6':IOS.bg}
                              onMouseLeave={e=>e.currentTarget.style.backgroundColor=esNuevo?'#FFFDF0':IOS.surface}>
                              <td style={{ padding:'8px 10px', color:IOS.label3, fontSize:'0.7rem' }}>{(pagina-1)*rpp+idx+1}</td>
                              <td style={{ padding:'8px 10px', fontFamily:'monospace', color:IOS.label2, fontSize:'0.7rem' }}>{d.codigoMed}</td>
                              <td style={{ padding:'8px 10px', maxWidth:260 }}>
                                <Tooltip title={d.producto} placement="top">
                                  <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:260, color:IOS.label }}>{d.producto}</span>
                                </Tooltip>
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center' }}>
                                <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.4, px:0.8, py:0.2, borderRadius:'20px',
                                  bgcolor:d.tipoProducto==='M'?'#EBF5FF':'#FFF5E6',
                                  border:`1px solid ${d.tipoProducto==='M'?'#BFDBFE':'#FED7AA'}` }}>
                                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:d.tipoProducto==='M'?IOS.blue:IOS.orange }}>
                                    {d.tipoProducto==='M'?'MED':'INS'}
                                  </Typography>
                                </Box>
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center' }}>
                                {d.estrategico==='E' && (
                                  <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px', bgcolor:'#FFF8E6', border:'1px solid #FFE9A0' }}>
                                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#8B6914' }}>Estrat.</Typography>
                                  </Box>
                                )}
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'right', color:IOS.label, fontVariantNumeric:'tabular-nums' }}>{fmt2(d.cpma)}</td>
                              <td style={{ padding:'8px 10px', textAlign:'right', color:IOS.label, fontVariantNumeric:'tabular-nums' }}>{fmt2(d.stockIpress)}</td>
                              <td style={{ padding:'8px 10px', textAlign:'right', color:IOS.label, fontVariantNumeric:'tabular-nums' }}>{fmt2(d.msd)}</td>
                              <td style={{ padding:'8px 10px' }}><IndPill valor={d.indicadorDigemid} /></td>
                              <td style={{ padding:'8px 10px', textAlign:'right', color:IOS.label, fontVariantNumeric:'tabular-nums' }}>{fmt2(d.stockAlmacenes)}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center' }}>
                                <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.4, px:0.8, py:0.2, borderRadius:'20px',
                                  bgcolor:d.disponibleAlmacen==='SI'?'#EDFAF2':'#FFF0EF',
                                  border:`1px solid ${d.disponibleAlmacen==='SI'?'#B7EFD0':'#FFD4D1'}` }}>
                                  <Box sx={{ width:4, height:4, borderRadius:'50%', bgcolor:d.disponibleAlmacen==='SI'?IOS.green:IOS.red }} />
                                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:d.disponibleAlmacen==='SI'?'#1A6B3C':'#C0392B' }}>
                                    {d.disponibleAlmacen==='SI'?'Si':'No'}
                                  </Typography>
                                </Box>
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center' }}>
                                {esNuevo && (
                                  <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px', bgcolor:'#FFF8E6', border:'1px solid #FFE9A0' }}>
                                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#8B6914' }}>NUEVO</Typography>
                                  </Box>
                                )}
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'right', color:IOS.label, fontVariantNumeric:'tabular-nums' }}>{fmt2(d.consumoEstimado)}</td>
                              <td style={{ padding:'4px 8px', textAlign:'right', backgroundColor:reqVal>0?`${IOS.blue}08`:'transparent' }}>
                                <input type="number" min="0" value={d.requerimiento}
                                  onChange={e=>editarReq(d._id,e.target.value)}
                                  style={{ width:75, textAlign:'right', fontVariantNumeric:'tabular-nums',
                                    border:`1px solid ${reqVal>0?`${IOS.blue}40`:IOS.separator}`,
                                    borderRadius:8, padding:'3px 8px', fontSize:'0.78rem',
                                    fontWeight:reqVal>0?700:400, color:reqVal>0?IOS.blue:IOS.label,
                                    background:IOS.surface, outline:'none', fontFamily:'inherit' }}
                                  onFocus={e=>e.target.style.borderColor=IOS.blue}
                                  onBlur={e=>e.target.style.borderColor=parseFloat(e.target.value||0)>0?`${IOS.blue}40`:IOS.separator} />
                              </td>
                              <td style={{ padding:'4px 8px', textAlign:'center', width:36 }}>
                                <Tooltip title="Quitar fila" placement="top">
                                  <Box component="button" type="button" aria-label={`Quitar ${d.producto}`} onClick={()=>eliminarFila(d._id)}
                                    sx={{ width:26, height:26, borderRadius:'50%', bgcolor:IOS.bg,
                                      display:'inline-flex', alignItems:'center', justifyContent:'center',
                                      cursor:'pointer', transition:'all 0.15s', '&:hover':{ bgcolor:'#FFF0EF' } }}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
                                      <polyline points="3 6 5 6 21 6"/>
                                      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                                      <path d="M10 11v6M14 11v6"/>
                                    </svg>
                                  </Box>
                                </Tooltip>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Box>
                  <Paginacion total={datosFiltrados.length} pagina={pagina} setPagina={setPagina} rpp={rpp} setRpp={setRpp} />
                </Box>
              </Box>
            )}
          </Box>
        )}

        {/* ── TAB 1: HISTORIAL / GESTIÓN ── */}
        {tabPrincipal===1&&(
          <Box>
            {detalleReq
              ? <DetalleRequerimiento
                  req={detalleReq}
                  esTOTAL={esTOTAL}
                  estados={ESTADOS}
                  user={user}
                  ueId={ueId}
                  onVolver={()=>setDetalleReq(null)}
                  onCambiarEstado={cambiarEstado}
                  onRecargar={()=>cargarDetalle(detalleReq.cabecera.REQ_ID)}
                  api={api}
                />
              : <HistorialRequerimientos
                  historial={historial}
                  loading={loadHist}
                  esTOTAL={esTOTAL}
                  estados={ESTADOS}
                  onRecargar={cargarHistorial}
                  onVerDetalle={(req)=>{ setReqSelec(req); cargarDetalle(req.REQ_ID); }}
                  ipressList={ipressList}
                  filtroIpress={filtroIpress}
                  setFiltroIpress={setFiltroIpress}
                />
            }
          </Box>
        )}
        {/* ── TAB 2: DASHBOARD ── */}
        {tabPrincipal===2&&esTOTAL&&(
          <DashboardRequerimiento ueId={ueId} api={api} estados={ESTADOS}/>
        )}

      </Box>
    </Box>
  );
};

export default Requerimiento;
